 window.webLanguage = ['zh-CN', 'USA', 'JP', 'KO','TH'];
 window.commonlanguage={
  'zh-CN':'简体中文',
  'USA':'English',
  'JP':'日本語',
  'KO':'한국어',
  'TH':'ภาษาไทย',
}
 homePageTitle = {
      'zh-CN': '旅悦集团官网-花筑、蔚徕、索性、柏纳、BEU酒店品牌',
      'USA': 'Lvyue Group Official Website -Floral, Vyluk, SuoXing, Urba, BEU Hotel Brand',
      'JP': 'ホテルハイアットの公式サイト：花築、納、BEUホテルブランド',
      'KO': '나트위그룹 공식홈페이지-꽃축, 플로어, 모성, 베르나, BEU호텔 브랜드',
      'TH':'เครือข่ายของเจ้าหน้าที่อาวุโสแอมะหลินทอรี่-ดอกไม้, โซนาร์, เบอร์นาร์ด, และยี่ห้อโรงแรมบีอีย',
    },
    joinUsTitle = {
      'zh-CN': '酒店加盟优势/政策_热线/电话/流程/咨询-旅悦集团官网',
      'USA': 'Franchise& Cooperation',
      'JP': 'ホテル加盟優位/政策_ホットライン/電話/手順/お問い合わせ-ホテルハイアットグループ公式サイト',
      'KO': '호텔 가입의 장점/정책_핫라인/전화/절차/컨설팅 - Lvyue그룹 공식 사이트.',
      'TH':'นโยบายการผูกมัดโรงแรม/นโยบาย_ฮอตไลน์/การโทรศัพท์/การขอคําปรึกษา ผู้บริหารกลุ่มนักเดินทาง. ',
    },
    commonHomePage = {
      'zh-CN': '首页',
      'USA': 'Home Page',
      'JP': 'ホームページ',
      'KO': '홈 페이지',
      'TH':'หน้าแรก',
    },
    commonLvyue = {
      'zh-CN': '旅悦集团',
      'USA': 'LvYue Group',
      'JP': 'Lvyueグループ',
        'KO': 'Lvyue 그룹',
         'TH':'กลุ่ม Lvyue',
    },
    commonLvyue1 = {
      'zh-CN': '旅悦集团 <span class="arrow"></span>',
      'USA': 'LvYue Group <span class="arrow"></span>',
      'JP': 'Lvyueグループ <span class="arrow"></span>',
        'KO': 'Lvyue 그룹 <span class="arrow"></span>',
          'TH':'กลุ่ม Lvyue <span class="arrow"></span>',
    },
    commonAboutLvyue={
      'zh-CN': '关于旅悦',
      'USA': 'About LvYue Group',
      'JP': 'LvYueグループについて',
        'KO': 'LvYue 그룹 소개',
           'TH':'เกี่ยวกับกลุ่ม LvYue',
    },
    commonlvyueBrand={
      'zh-CN': '旅悦品牌 <span class="arrow"></span>',
      'USA': 'LvYue Brands <span class="arrow"></span>',
      'JP': 'LvYueブランド',
        'KO': 'LvYue 브랜드',
          'TH':'แบรนด์ LvYue',
    },
    commonFlowerConstruction={
      'zh-CN': '花筑',
      'USA': 'Floral',
      'JP': 'フローラル',
        'KO': '플로랄',       'TH':'ดอกไม้',
    },
    commonClaim={
      'zh-CN': '索性',
      'USA': 'Suoxing',
      'JP': 'サックス',
        'KO': 'Suoxing',
             'TH':'Suoxing',
    },
    commonWeiLai={
      'zh-CN': '蔚徕',
      'USA': 'Vyluk',
      'JP': 'ヴィルック',
        'KO': 'Vyluk',
           'TH':'Vyluk',
    },
    commonClaimChoice={
      'zh-CN': '索性精选',
      'USA': 'Suoxing Choice',
      'JP': 'Suoxingの選択',
        'KO': 'Suoxing Choice',
            'TH':'ทางเลือกที่เหมาะสม',
    },
    commonBaina={
      'zh-CN': '柏纳',
      'USA': 'URBA',
      'JP': 'URBA',
        'KO': 'URBA',
            'TH':'Urba',
    },
    commonBeU={
      'zh-CN': 'BeU',
      'USA': 'BeU',
      'JP': 'BeU',
        'KO': 'BeU',       'TH':'BeU',
    },
    commonflowerTravel={
      'zh-CN': '花筑旅行',
      'USA': 'Floral Trip',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonJoinInCooperation={
      'zh-CN': '加盟合作',
      'USA': 'Franchise & Cooperation',
      'JP': 'フランチャイズと協力',
        'KO': '프랜차이즈 및 협력',
          'TH':'แฟรนไชส์และความร่วมมือ',
    },
    commonPaidInformation={
      'zh-CN': '付费资讯',
      'USA': 'Paid Information',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonZh={
      'zh-CN': '简体中文',
      'USA': '简体中文',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonUsa={
      'zh-CN': 'English',
      'USA': 'English',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonJp={
      'zh-CN': '日语',
      'USA': 'Japanese',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonKo={
      'zh-CN': '韩语',
      'USA': 'Korean',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonReservations={
      'zh-CN': '预订酒店',
      'USA': 'Reservation',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonClose={
      'zh-CN': '关闭',
      'USA': 'Close',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonFreebooking={
      'zh-CN': '免费订房热线',
      'USA': 'Free Booking Hotline',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonDownload={
      'zh-CN': '下载花筑旅行APP预订酒店',
      'USA': 'Download Floral Travel APP for Hotel Reservation',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonWechatSubscription={
      'zh-CN': '关注花筑旅行公众账号',
      'USA': 'Follow Floral Travel on Wechat',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonHuazhuSubscription={
      'zh-CN': '旅悦集团微信公众号',
      'USA': 'LvYue Group Wechat ID',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonBrandintroductio={
      'zh-CN': '品牌介绍',
      'USA': 'About the Brand',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonWantJoin={
      'zh-CN': '我要加盟',
      'USA': 'Join Us',
      'JP': '',
        'KO': '',       'TH':'English <span class="arrow"></span>',
    },
    commonConectUs={
      'zh-CN': '联系我们',
      'USA': 'Contact Us',
      'JP': '연락처',
        'KO': '連絡しろ',
           'TH':'ติดต่อเรา',
    },
    commonCustomerServiceHotline={
      'zh-CN': '客服电话',
      'USA': 'Customer Service Hotline',
      'JP': 'カスタマーサービスホットライン',
        'KO': '고객 서비스 핫라인',
          'TH':'สายด่วนบริการลูกค้า',
    },
    commonCompanyInfo={
      'zh-CN': '旅悦(天津)酒店管理有限公司 丨 备案号：',
      'USA': 'LvYue (Tianjin) Hotel Management Co., Ltd. 丨 Registered No.: ',
      'JP': '旅悦（天津）ホテル管理有限会社丨3階、ビルA1、東勝テクノロジーパーク、66 Xixiaokou Road、海淀区、北京100080、中国中国丨登録番号：',
        'KO': 'LvYue（천진）호텔 관리 유한회사 丨 북경 해전 구 Xixiaokou 도로 Dongsheng 기술 공원 A1 빌딩 3 층, 중국 북경 100080, 丨 등록 번호 :',
          'TH':'LvYue (เทียนจิน) การจัดการโรงแรม จำกัด 丨ชั้น 3 อาคาร A1, Dongsheng Technology Park, 66 Xixiaokou Road, Haidian District, Beijing 100080, P.R. China หมายเลขจดทะเบียน: ',
    },
     commonCompanyBeianInfo={
         'zh-CN': '京ICP备17066056号-1',
         'USA': 'BJ ICP Reg. No. 17066056-1',
         'JP': 'BJ ICP登録。 No. 17066056-1',
         'KO': 'BJ ICP 등록. 번호 17066056-1',
         'TH': 'BJ ICP หมายเลข 17066056-1',
     },
     commonCompanyBeianText={
      'zh-CN': '京公网安备 11010802034175号',
      'USA': '',
      'JP': '',
      'KO': '',
      'TH': '',
      'YH': '',
    }
    commonCompanyCubmitSuccess={
      'zh-CN': '提交信息成功！',
      'USA': 'Successful submission of information! ',
      'JP': '情報の提出に成功しました！',
        'KO': '성공적인 정보 제출!',
         'TH':'ส่งข้อมูลสำเร็จแล้ว!',
    },
    commonCompanySubmit={
      'zh-CN': '提交',
      'USA': 'Submit',
      'JP': '提出する',
        'KO': '제출',
         'TH':'เสนอ',

    },
    commonCompanyCubmitFail={
      'zh-CN': '提交失败',
      'USA': 'Submission Failed',
      'JP': '',
        'KO': '',
           'TH':'English <span class="arrow"></span>',
    },
    homePageSwiperOneTitle={
      'zh-CN': '旅至美 悦于宿',
      'USA': 'Splendid Scenery, Joyful Stay',
      'JP': '素晴らしい風景、楽しい滞在',
      'KO': '아름다운 경관, 즐거운 숙박',
      'TH':'ทิวทัศน์ที่สวยงามการพักอย่างมีความสุข',
    },
    homePageSwiperTwoTitle={
      'zh-CN': '我们的环境',
      'USA': 'Our Environment',
      'JP': '私たちの環境',
        'KO': '우리 주변 환경',
       'TH':'สภาพแวดล้อมของเรา',
    },
    homePageSwiperThreeTitle={
      'zh-CN': '我们的足迹',
      'USA': 'Our Network',
      'JP': '私たちの足跡',
        'KO': '우리 발자취',       'TH':'รอยเท้าของเรา',
    },
    homePageSwiperThreeInfo={
      'zh-CN': '旅悦集团已在全球签约、开业超过1900家酒店，遍布包括日本、韩国、泰国、印度、新西兰、澳大利亚等在内的全球10余个国家的200多个目的地',
      'USA': 'The LvYue Group has brought more than 1900 hotels worldwide into its network, covering more than 200 destinations in more than 10 countries including China, Japan, South Korea, Thailand, India, New Zealand and Australia. ',
      'JP': '弊社グループは、既に世界中に1900棟のホテルを開業致しました。日本、韓国、タイ、インド、ニュージーランド、オーストラリアなど10か国以上に200以上の目的地をカバーしており',
      'KO': 'LvYue그룹은 일본,한국,태국,인도,뉴질랜드,호주포함 10여개국,200여개지역에서 1900개호텔을 계약 및 오픈 하였으며, ',
      'TH':'กลุ่มบริษัท LvYue ได้ลงทะเบียนและเปิดโรงแรมมากกว่า 1900 แห่งทั่วโลก ครอบคลุมมากกว่า 200 จุดหมายปลายทางในมากกว่า 10 ประเทศ รวมถึงญี่ปุ่น เกาหลีใต้ ไทย อินเดีย นิวซีแลนด์ ออสเตรเลีย ฯลฯ',
    },
    homePageSwiperThreeOpenedArea={
      'zh-CN': '已开业地区',
      'USA': 'Open',
      'JP': 'オープンエリア',
        'KO': '열린 지역',
            'TH':'พื้นที่เปิดโล่ง',
    },
    homePageSwiperTobeOpenedArea={
      'zh-CN': '待开业地区',
      'USA': 'Upcoming ',
      'JP': 'オープン予定エリア',
        'KO': '열린 지역',
          'TH':'พื้นที่ที่จะเปิด',
    },
    homePageSwiperThreeKohSamui={
      'zh-CN': '苏梅岛',
      'USA': 'Koh Samui',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeBeijing={
      'zh-CN': '北京',
      'USA': 'Beijing',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeNanjing={
      'zh-CN': '南京',
      'USA': 'Nanjing',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeMoganmountain={
      'zh-CN': '莫干山',
      'USA': 'Mount Mogan',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeNanxun={
      'zh-CN': '南浔',
      'USA': 'Nanxun',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeAnji={
      'zh-CN': '安吉',
      'USA': 'Anji',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeSeoul={
      'zh-CN': '首尔',
      'USA': 'Seoul',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeChiangmai={
      'zh-CN': '清迈',
      'USA': 'Chiangmai',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeXishuangbanna={
      'zh-CN': '西双版纳',
      'USA': 'Xishuangbanna',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeDali={
      'zh-CN': '大理',
      'USA': 'Dali',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeLijiang={
      'zh-CN': '丽江',
      'USA': 'Lijiang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeChongqie={
      'zh-CN': '重庆',
      'USA': 'Chongqing',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeLangzhonge={
      'zh-CN': '阆中',
      'USA': 'Langzhong',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeGuohuang={
      'zh-CN': '敦煌',
      'USA': 'Dunhuang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeLibo={
      'zh-CN': '荔波',
      'USA': 'Libo',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeZhangjiajie={
      'zh-CN': '张家界',
      'USA': 'Zhangjiajie',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeHuangshan={
      'zh-CN': '黄山',
      'USA': 'Mount Huang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeHangzhou={
      'zh-CN': '杭州',
      'USA': 'Hangzhou',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeChejudo={
      'zh-CN': '济州岛',
      'USA': 'Jeju',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeFenghuang={
      'zh-CN': '凤凰',
      'USA': 'Fenghuang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeSemporna={
      'zh-CN': '仙本那',
      'USA': 'Semporna',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeWuzhen={
      'zh-CN': '乌镇',
      'USA': 'Wuzhen',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeSuzhou={
      'zh-CN': '苏州',
      'USA': 'Suzhou',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeGuilin={
      'zh-CN': '桂林',
      'USA': 'Guilin',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeWulong={
      'zh-CN': '武隆',
      'USA': 'Wulong',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeXian={
      'zh-CN': '西安',
      'USA': "Xi'an",
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreePingyao={
      'zh-CN': '平遥',
      'USA': 'Pingyao',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeXiamen={
      'zh-CN': '厦门',
      'USA': 'Xiamen',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeLishui={
      'zh-CN': '丽水',
      'USA': 'Lishui',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeXitang={
      'zh-CN': '西塘',
      'USA': 'Xitang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeSingapore={
      'zh-CN': '新加坡',
      'USA': 'Singapore',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeKualaLumpur={
      'zh-CN': '吉隆坡',
      'USA': 'Kuala Lumpur',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreePenang={
      'zh-CN': '槟城',
      'USA': 'Penang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreePhuket={
      'zh-CN': '普吉岛',
      'USA': 'Phuket ',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeLangkawi={
      'zh-CN': '兰卡威',
      'USA': 'Langkawi',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreePhnomPenh={
      'zh-CN': '金边',
      'USA': 'Phnom Penh',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeKotaKinabalu={
      'zh-CN': '哥打京那巴鲁',
      'USA': 'Kota Kinabalu',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreePattaya={
      'zh-CN': '芭提雅',
      'USA': 'Pattaya',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeBangkok={
      'zh-CN': '曼谷',
      'USA': 'Bangkok',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeSiemReap={
      'zh-CN': '暹粒',
      'USA': 'Siem Reap',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeNhaTrang={
      'zh-CN': '芽庄',
      'USA': 'Nha Trang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeDaNang={
      'zh-CN': '岘港',
      'USA': 'Da Nang',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeCebu={
      'zh-CN': '宿务',
      'USA': 'Cebu',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeBoracayIsland={
      'zh-CN': '长滩岛',
      'USA': 'Boracay Island',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeManila={
      'zh-CN': '马尼拉',
      'USA': 'Manila',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeHanoi={
      'zh-CN': '河内',
      'USA': 'Hanoi',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeHongKong={
      'zh-CN': '香港',
      'USA': 'Hong Kong',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeKaohsiung={
      'zh-CN': '高雄',
      'USA': 'Kaohsiung',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeHualian={
      'zh-CN': '花莲',
      'USA': 'Hualien',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeTaipei={
      'zh-CN': '台北',
      'USA': 'Taipei',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeTengchong={
      'zh-CN': '腾冲',
      'USA': 'Tengchong',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeShangriLa={
      'zh-CN': '香格里拉',
      'USA': 'Shangri-La',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeWuyiMount={
      'zh-CN': '武夷山',
      'USA': 'Mount Wuyi',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeJiaxing={
      'zh-CN': '嘉兴',
      'USA': 'Jiaxing',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeRizhao={
      'zh-CN': '日照',
      'USA': 'Rizhao',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeBusan={
      'zh-CN': '釜山',
      'USA': 'Busan',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeOsaka={
      'zh-CN': '大阪',
      'USA': 'Osaka',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeTokyo={
      'zh-CN': '东京',
      'USA': 'Tokyo',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreekyoto={
      'zh-CN': '京都',
      'USA': 'Kyoto',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperThreeXinzhou={
      'zh-CN': '忻州',
      'USA': 'Xinzhou',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFourTitle={
      'zh-CN': '我们的品牌',
      'USA': 'Our Brands',
      'JP': '私達のブランド',
        'KO': '우리 브랜드',
          'TH':'แบรนด์ของเรา',
    },
    homePageSwiperFourBrandintroduction={
      'zh-CN': '品牌介绍：',
      'USA': 'About the Brands：',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperBrandintroductionInof1={
      'zh-CN': '花筑在全球范围内甄选极致风景。\<br>隐藏在古镇，坐落在山间或湖边，花筑集合一系列独一无二的风景。每一家都融合了在地文化、设计&氛围，用热情、温暖、个性化的服务欢迎每一位游客。',
      'USA': 'Floral Hotel selects the most splendid sceneries in every corner of the world. \n' +
          'Hidden in an old town, secluded on a mountain side or lake shore, the brand gathers a collection of unique addresses. Each hotel combines local cultures, design & atmosphere to welcome travellers with emotion and a warm personalised service. ',
      'JP': 'フローラルホテルはLvYueグループの最初のブティックリゾートホテルブランドです。 それは7センスサービスに基づいてほとんどの文化的な特性でリゾートスペースを創造するよう努めます。 フローラルホテルは、フローラルシティ、フローラルジョイ、フローラルおよびフローラルラックスの4つのサブブランドに分類されます。',
        'KO': '플로랄 호텔은 LvYue Group의 최초 부티크 리조트 호텔 브랜드입니다. 7 가지 감각 서비스를 기반으로 대부분의 문화적 특성을 갖춘 리조트 공간을 조성하기 위해 노력합니다. 플로랄 호텔은 플로랄 시티 (Floral-City), 플로럴 - 조이 (Floral-Joy), 플로랄 - 플로랄 - 럭스의 4 가지 하위 브랜드로 나뉘어져 있습니다.',
           'TH':'Floral Hotel เป็นแบรนด์โรงแรมบูติกแห่งแรกของกลุ่ม LvYue มันมุ่งมั่นที่จะสร้างพื้นที่รีสอร์ทที่มีลักษณะทางวัฒนธรรมส่วนใหญ่ขึ้นอยู่กับบริการเจ็ดความรู้สึกของมัน โรงแรมฟลอรัลแบ่งออกเป็นสี่แบรนด์ย่อย: ฟลอรัล - ซิตี้ฟลอรัล - จอยฟลอรัลและฟลอรัล - ลักซ์',
    },
    homePageSwiperFourDesignidea={
      'zh-CN': '设计理念：',
      'USA': 'Design Philosophy：',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFourDesignideaInfo1={
      'zh-CN': '精品度假酒店',
      'USA': 'Scenic Boutique Hotels & Resorts',
      'JP': 'ブティックホリデイズホテルズ＆リゾーツ',
        'KO': '부티크 휴일 호텔 & 리조트',
              'TH':'โรงแรมและรีสอร์ทบูติคฮอลิเดย์',
    },
    homePageSwiperFourSite={
      'zh-CN': '场',
      'USA': 'Site',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFourView={
      'zh-CN': '景：',
      'USA': 'View：',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFourBusinesstrip={
      'zh-CN': '净如索性   随心而居',
      'USA': 'Smart Rates for Smart Travellers',
      'JP': '清潔で安いのが好きな旅行者のために',
        'KO': '깔끔하고 저렴한 여행객들에게',
            'TH':'สำหรับนักท่องเที่ยวที่รักความเรียบร้อย & ราคาถูก',
    },
    homePageSwiperFourBrandintroductionInof2={
      'zh-CN': '为满足⽤户个性化、品质化、多元化、社交化、共享化等多维度的入住需求，Vyluk蔚徕酒店遴选城市核心地块，塑造城市酒店新风向。\<br>设计上，注重⽣活⽅式的营造与细节的打磨，不仅为客人在客房提供安眠、影⾳音及舒适的空间体验，同时酒店公共空间可以实现多功能转换，不仅有效提高空间的利用性，更实现了生活与酒店共享空间的完美集合。<br>链接一切美好，以不凡见未来',
      'USA': 'Based in city hotspots, Vyluk is a new style of urban hotel, welcoming guests who seek more than just a cosy room and restaurant. Innovative and tech-friendly, with multifunctional, convertible spaces designed for a versatile lifestyle, Vyluk Hotels provide practical, clean, comfortable and convivial environments for creative meetings, relaxation and social gatherings.  ',
      'JP': '都市のホットスポットを拠点とするVylukは、居心地の良い客室とレストランを求めるお客様を歓迎する都会のホテルの新しいトレンドです。革新的で、技術に優しく、そして多機能なコンバーチブルスペースは、多様なライフスタイルのために想像されます。 Vylukホテルでは、創造的な会議、リラクゼーション、社交的な集まりをお探しの方に実用的で清潔で快適で陽気な環境を提供しています。',
        'KO': 'Vyluk은 도시의 핫 스폿을 기반으로 아늑한 객실과 레스토랑을 찾는 손님을 환영하는 도시형 호텔의 새로운 트렌드입니다. 혁신적이고 기술 친화적 인 다기능 컨버터블 공간은 다양한 라이프 스타일을 상상합니다. Vyluk 호텔은 창조적 인 회의, 휴식 또는 사교 모임을 찾는 사람들에게 실용적이고 깨끗하며 편안하고 상냥한 환경을 제공합니다.',
           'TH':'Vyluk ตั้งอยู่ในจุดร้อนของเมืองเป็นเทรนด์ใหม่ของโรงแรมในเมืองที่ต้อนรับแขกที่กำลังมองหามากกว่าห้องพักและร้านอาหารที่สะดวกสบาย นวัตกรรมช่องว่างที่เปลี่ยนแปลงได้เป็นมิตรกับเทคโนโลยีและมัลติฟังก์ชั่นได้รับการจินตนาการสำหรับไลฟ์สไตล์ที่หลากหลาย โรงแรม Vyluk จัดหาสภาพแวดล้อมที่สะอาดสะดวกสบายและสนุกสนานสำหรับผู้ที่มองหาการประชุมสร้างสรรค์การพักผ่อนหรือการสังสรรค์ทางสังคม',
    },
    homePageSwiperFourDesignideaInfo2={
      'zh-CN': '中端城市酒店',
      'USA': 'Mid-range City Hotel',
      'JP': '中価格帯シティホテル',
        'KO': '미드 레인지 시티 호텔',
             'TH':'โรงแรมระดับกลาง',
    },
    homePageSwiperFourTourismVacationSocialBusiness={
      'zh-CN': 'Vyluk蔚徕酒店 - 新一代生活方式酒店',
      'USA': 'Vyluk Hotel - For A New-Generation Lifestyle',
      'JP': 'Vyluk Hotel  - 新世代のライフスタイルのために',
        'KO': 'Vyluk Hotel - 차세대 라이프 스타일을위한',
          'TH':'Vyluk Hotel - สำหรับไลฟ์สไตล์ยุคใหม่',
    },

    homePageSwiperFourBrandintroductionInof4={
      'zh-CN': '考虑到当今休闲和商务旅客的需求，我们确保酒店的现代化设施拥有所有的必备条件，为您提供高性价比的住宿体验，带来无与伦比的舒适享受。 \n' +
          '每一家索性精选酒店的设计都各有特色，每一家索性精选酒店的品质与服务都始终如一。\n' +
          '每一天，我们团队的服务都致力于为客人带来不同体验。我们积极的态度、体贴的关注以及发自内心的微笑，是让客人在熙熙攘攘的城市喧嚣中享受愉快住宿体验的关键。 ',
      'USA': 'With the needs of today’s leisure and business travellers in mind, we make sure that our modern facilities boast all the must-haves for an affordable and convenient stay, spiced up with a touch of fun, providing unmistakable comfort. <br/>While each hotel harbours its unique design, all deliver a high quality service and decor. Every day, our team\'s purpose is to make a difference for our guests. Our positive attitude and professional attention, enriched with smiles from the heart, are key to engaging our guests and providing them with a pleasant stay, sheltered from the hustle and bustle of the city.',
      'JP': ' 今日のレジャーやビジネスの旅行者のニーズを念頭に置いて、私たちの近代的な施設は紛れもない快適さのために楽しくタッチして手頃な価格で便利な滞在のためのすべての必需品を誇っています。心からの笑顔で豊かにされた私たちの前向きな姿勢と専門的な注意は、活気に満ちた街の無秩序から守られた楽しい滞在に私たちのゲストを巻き込むための鍵です。',
        'KO': '오늘의 레저 여행객과 비즈니스 여행객의 요구를 염두에두고 우리는 현대적인 시설이 합리적이고 편리한 체류를 위해 모든 필수 아이템을 자랑하는지 확인합니다. 우리의 긍정적 인 태도와 전문적인 관심은 가슴이 피곤한 도시의 무정부 상태에서 보호받는 쾌적한 체류를 위해 손님을 끌어들이는 열쇠입니다.',
             'TH':'ด้วยความต้องการของนักเดินทางเพื่อธุรกิจและการพักผ่อนในปัจจุบันเราจึงมั่นใจว่าสิ่งอำนวยความสะดวกที่ทันสมัยของเรามีทุกสิ่งที่จำเป็นสำหรับการเข้าพักในราคาที่ไม่แพงและสะดวกสบายพร้อมสัมผัสความสนุกเพื่อความสะดวกสบายที่ไม่มีใครเหมือน ทัศนคติเชิงบวกและการเอาใจใส่จากมืออาชีพที่เต็มไปด้วยรอยยิ้มจากหัวใจเป็นกุญแจสำคัญที่จะทำให้แขกของเรามีส่วนร่วมในการพักอย่างรื่นรมย์ซึ่งได้รับการปกป้องจากความโกลาหลของเมืองที่วุ่นวาย',
    },
    homePageSwiperFourDesignideaInfo4={
      'zh-CN': '中档商务酒店',
      'USA': 'Mid-range Business Hotel',
      'JP': '中価格帯ビジネスホテル',
        'KO': '미드 레인지 비즈니스 호텔',
            'TH':'โรงแรมธุรกิจระดับกลาง',
    },
    homePageSwiperFourMotto4={
      'zh-CN': '索性精选，品质之选',
      'USA': 'Smartly Enjoyable',
      'JP': 'とても楽しい',
        'KO': '똑똑하게 즐거운 시간',
            'TH':'สนุกอย่างชาญฉลาด',
    },
    homePageSwiperFourBrandintroductionInof5={
      'zh-CN': '柏纳酒店聚焦商旅客人对酒店的核心诉求，提供舒适和实用之间的微妙平衡，专注舒适的环境和一流的服务。\<br>每一家柏纳酒店都是独一无二的，所有酒店都致力于为客人提供舒适的环境和一流的服务，以满足客人真正需要的高品质标准。',
      'USA': 'With a subtle balance of comfort and practicality, URBA Hotels welcome their guests with flexible and modern spaces designed to melt away the stress of travel.  Our hotels focus on the most important needs of business travellers, delivering upscale quality facilities and services.<br/>While every URBA hotel is unique, all thrive to deliver a cosy environment and first-class service to guests seeking a high standard of quality in the things they really need.',
      'JP': '快適さと実用性の微妙なバランスで、URBAホテルは彼らの旅を落ち着かせるために捧げられる柔軟でモダンなスペースでお客様を歓迎します。当ホテルは高級な施設とサービスを提供するビジネス旅行者の最も重要なニーズに焦点を合わせています。すべてのURBAホテルはユニークですが、すべては、彼らが本当に必要とするもののために高水準の品質を求めているゲストに運命づけられた居心地の良い環境と一流のサービスを提供するために繁栄します。',
        'KO': 'URBA Hotels는 편안함과 실용성의 조화 로움을 바탕으로 유연하고 현대적인 공간을 고객에게 제공합니다. 저희 호텔은 고품격 시설과 서비스를 제공하는 비즈니스 여행객의 가장 중요한 요구 사항에 중점을 둡니다. URBA의 모든 호텔은 독특하지만, 모두가 필요로하는 것들을 위해 높은 수준의 품질을 추구하는 손님들을위한 아늑한 환경과 일류 서비스를 제공하기 위해 번성합니다.',
           'TH':'ด้วยความสมดุลของความสะดวกสบายและการใช้งานได้จริงโรงแรม URBA ยินดีต้อนรับแขกด้วยพื้นที่ที่ยืดหยุ่นและทันสมัยที่อุทิศตนเพื่อการเดินทางของพวกเขา โรงแรมของเรามุ่งเน้นไปที่ความต้องการที่สำคัญที่สุดของนักธุรกิจที่ให้บริการสิ่งอำนวยความสะดวกและบริการคุณภาพสูง ในขณะที่โรงแรม URBA ทุกแห่งนั้นมีเอกลักษณ์ไม่เหมือนใครทุกคนต่างมุ่งมั่นที่จะมอบสภาพแวดล้อมที่สะดวกสบายและบริการชั้นหนึ่งที่กำหนดไว้สำหรับแขกที่แสวงหาคุณภาพมาตรฐานระดับสูงสำหรับสิ่งที่พวกเขาต้องการ',
    },
    homePageSwiperFourDesignideaInfo5={
      'zh-CN': '中端城市酒店',
      'USA': 'Mid-range Business Hotel',
      'JP': '中価格帯シティホテル',
        'KO': '미드 레인지 시티 호텔',       'TH':'โรงแรมระดับกลาง',
    },
    homePageSwiperFourMotto5={
      'zh-CN': '聚焦你的核心诉求',
      'USA': 'Balance your Essentials',
      'JP': 'あなたの本質のバランスをとる',
        'KO': '필수 요소의 균형 유지',
            'TH':'ปรับสมดุลของ Essentials ของคุณ',
    },
    homePageSwiperFourBrandintroductionInof6={
      'zh-CN': '干净便捷的设施，清新怡人的氛围，热情周到的服务，我们为商务和休闲旅客提供不可或缺的高品质舒适体验。\<br>困了？饿了? 放松？娱乐？休闲？学习? 不要压抑你的情绪，做你想做的，成全原本的自己。',
      'USA': 'Economy hotel doesn’t mean no character!<br/>A warm welcome, a deep sleep, a power shower, an energising breakfast and tasty meals, creative meeting spaces… Your stay with us is spirited all along the way. Clean and convenient facilities, a refreshing and inviting atmosphere, enthusiastic and thoughtful attention, BeU Hotels focus on the quality of our guests\' indispensables to offer a pleasant experience for both business and leisure travellers.<br/>Sleepy or hungry?  Relaxed or busy? Mellow or playful?<br/>Whatever your mood.',
      'JP': '清潔で便利な設備、さわやかで心地良い雰囲気、熱心で思いやりのある注意、BeU Hotelsは、ビジネスとレジャーの両方の旅行者に快適な経験を提供するためにゲストの欠かせないものの品質に焦点を当てています。眠いか空腹ですか？リラックスしたり遊び心のある？居心地が良いか勉強するか気分を抑えないでください。',
        'KO': '깨끗하고 편리한 시설, 상쾌하고 매력적인 분위기, 열정과 사려 깊은 관심, BeU 호텔은 비즈니스 및 레저 여행객 모두에게 즐거운 경험을 제공하는 손님의 필수품의 품질에 중점을 둡니다. 졸리거나 배고프다? 휴식이나 장난기? 아늑한가 공부합니까? 기분을 제지하지 마십시오.',
           'TH':'สิ่งอำนวยความสะดวกที่สะอาดและสะดวกสบายบรรยากาศที่สดชื่นและน่าดึงดูดใจความใส่ใจและเอาใจใส่ BeU Hotels มุ่งเน้นไปที่คุณภาพของสิ่งที่ขาดไม่ได้ของผู้เข้าพักเพื่อมอบประสบการณ์ที่น่ารื่นรมย์สำหรับทั้งนักธุรกิจและนักท่องเที่ยว ง่วงนอนหรือหิว ผ่อนคลายหรือขี้เล่น? อบอุ่นใจหรือเรียนหนังสืออย่าควบคุมอารมณ์ของคุณ',
    },
    homePageSwiperFourDesignideaInfo6={
      'zh-CN': '经济型酒店',
      'USA': 'Economy Hotel',
      'JP': 'エコノミーホテル',
        'KO': '이코노미 호텔',
             'TH':'โรงแรมราคาประหยัด',
    },
    homePageSwiperFourMotto6={
      'zh-CN': '就做你自己',
      'USA': 'Just Be yoU',
      'JP': 'あなたらしく',
        'KO': 'Just Be You',
          'TH':'เพียงแค่เป็นคุณ',
    },

    homePageSwiperFiveJointheInformation={
      'zh-CN': '加盟信息',
      'USA': 'Franchise Information',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFiveInputName={
      'zh-CN': '请输入联系人姓名',
      'USA': 'Please enter your name ',
      'JP': '連絡先の名前を入力してください。',
        'KO': '연락처의 이름을 입력하십시오.',
            'TH':'กรุณาใส่ชื่อผู้ติดต่อ',
    },

    homePageSwiperFiveInputNameLong={
      'zh-CN': '输入姓名过长',
      'USA': 'Input name is too long',
      'JP': '이름을 너무 오래 입력하십시오',
        'KO': '輸入品のある都市は長すぎます',
           'TH':'ป้อนชื่อยาวเกินไป',
    },

    homePageSwiperFiveGirl={
      'zh-CN': '女士',
      'USA': 'Ms.',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFiveBoy={
      'zh-CN': '先生',
      'USA': 'Mr.',
      'JP': '',
        'KO': '',
            'TH':'',
    },
    homePageSwiperFiveInputPhone={
      'zh-CN': '请输入联系人手机号',
      'USA': 'Please enter your phone number ',
      'JP': '連絡先の電話番号を入力してください。',
        'KO': '연락 가능한 전화 번호를 입력하십시오.',
          'TH':'กรุณาใส่หมายเลขโทรศัพท์ติดต่อ',
    },
    homePageSwiperFiveInputAddress={
      'zh-CN': '请输入物业酒店所在地址',
      'USA': 'Please enter the address of proposed property',
      'JP': 'ホテルの住所を入力してください',
        'KO': '호텔이있는 도시를 입력하십시오.',
          'TH':'โปรดป้อนที่อยู่ของโรงแรมที่ให้บริการ',
    },
    homePageSwiperFiveInputAddressLong={
      'zh-CN': '输入物业所在城市过长',
      'USA': 'The city where the input property is located is too long ',
      'JP': '건물이 있는 도시를 입력하면 너무 길다',
        'KO': '輸入品のある都市は長すぎます',
            'TH':'เมืองที่นําเข้าข้อมูลมายาวนาน',
    },
    homePageSwiperFiveInputAddressError={
      'zh-CN': '请输入物业酒店所在城市',
      'USA': 'Please enter the city where the property hotel is located. ',
      'JP': 'ホテルのある都市を入力してください。',
        'KO': '호텔이있는 도시를 입력하십시오.',
          'TH':'กรุณากรอกเมืองที่เป็นที่ตั้งของโรงแรม',
    },
    homePageSwiperFiveInputPhoneError={
      'zh-CN': '请输入正确的手机号码',
      'USA': 'Please enter the correct mobile phone number. ',
      'JP': '携帯電話番号を入力してください。',
        'KO': '정확한 휴대 전화 번호를 입력하십시오.',
             'TH':'โปรดป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
    },
    homePageSwiperFiveInputSpace={
      'zh-CN': '请输入物业建筑面积',
      'USA': 'Input Area',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFiveInputSpaceError={
      'zh-CN': '请输入正确的物业面积',
      'USA': 'Input Correct Area',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFiveJoin={
      'zh-CN': '加盟',
      'USA': 'Franchise',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFiveJoinStep={
      'zh-CN': '加盟流程',
      'USA': 'It\'s Easy to Join LvYue',
      'JP': '参加プロセス',
        'KO': '프로세스 참여.',
            'TH':'เข้าสู่กระบวนการ',
    },
    homePageSwiperFiveMaterialcooperation={
      'zh-CN': '物料合作',
      'USA': 'Material Cooperation',
      'JP': '',
        'KO': '',       'TH':'',
    },
    homePageSwiperFiveJoinLvyue={
      'zh-CN': '加盟旅悦',
      'USA': 'Join LvYue Group',
      'JP': 'LvYueグループに参加する',
      'KO': 'LvYue 그룹 가입',
      'TH':'เข้าร่วมกลุ่ม LvYue',
    },
    homePageSwiperFiveJoinInfo={
      'zh-CN': '旅悦集团是携程集团的战略投资公司，以“携手大数据，拥抱互联网”为特色；致力于打造比肩全球的旅游全产业链服务商，现诚邀您筑梦掘金蔚徕，期待您的加盟。',
      'USA': 'Strategic investment from Ctrip, LvYue is a tourism group integrating hotel management, information technology and trade market purchases.  By tapping into big data, LvYue is devoted to building a whole-industry-chain service provider by applying Internet innovative technologies to the traditional tourism industry to enrich partners and guests experience.<br>We sincerely invite you to build our dreams and tap into future with us.<br>We look forward to your joining.',
      'JP': 'CtrYからの戦略的投資、LvYueは、ホテル管理、情報技術および貿易市場での購入を統合した観光グループです。ビッグデータを活用することで、LvYueはインターネットの革新的な技術を伝統的な観光業界に適用してパートナーとゲストの経験を豊かにすることで、業界全体のチェーンサービスプロバイダーを構築することに専念しています。私たちはあなたに私たちの夢を築き、私たちと一緒に未来を拓くように心から招待します。ご参加をお待ちしています。',
        'KO': 'Ctrip의 전략적 투자, LvYue는 호텔 경영, 정보 기술 및 무역 시장 구매를 통합하는 관광 그룹입니다. 큰 데이터를 활용함으로써 LvYue는 전통 관광 산업에 인터넷 혁신 기술을 적용하여 파트너 및 게스트 경험을 풍부하게함으로써 전체 산업 체인 서비스 제공 업체를 구축하는 데 전념합니다. 우리는 꿈을 쌓고 우리와 함께 미래를 열어 가도록 진심으로 초대합니다. 우리는 귀하의 가입을 기대합니다.',
           'TH':'การลงทุนเชิงกลยุทธ์จาก Ctrip LvYue เป็นกลุ่มการท่องเที่ยวที่ผสมผสานการจัดการโรงแรมเทคโนโลยีสารสนเทศและการซื้อในตลาดการค้า ด้วยการเจาะข้อมูลขนาดใหญ่ LvYue จึงมุ่งมั่นที่จะสร้างผู้ให้บริการทั้งอุตสาหกรรมโดยการใช้เทคโนโลยีอินเทอร์เน็ตที่เป็นนวัตกรรมเพื่ออุตสาหกรรมการท่องเที่ยวแบบดั้งเดิมเพื่อเสริมสร้างพันธมิตรและแขกผู้มีประสบการณ์ เราจริงใจเชิญคุณสร้างความฝันของเราและแตะกับอนาคตกับเรา เราหวังว่าจะเข้าร่วมของคุณ',
    },
    joinUsDreamofgoldnuggets={
      'zh-CN': '做顾客更需要的酒店',
      'USA': 'build dreams and tap into future',
      'JP': '顧客がもっと必要とするホテルになる',
        'KO': '고객이 더 필요로하는 호텔이 되십시오.',
          'TH':'เป็นโรงแรมที่ลูกค้าต้องการมากขึ้น',
    },
    groupAboutLvyue={
      'zh-CN': '旅悦集团成立于2016年，经去哪儿网内部孵化而成，前携程大住宿首席战略官周荣担任集团CEO。由携程集团战略投资，腾讯、红杉资本中国基金、百度资本、高盛集团、鸥翎投资、中信聚信、元禾原点、凯撒辉耀均为投资方。<br/><br/>是一家集酒店管理、信息技术服务、供应链采购贸易、文化旅游于一体的综合性旅游产业集团。依托资深的团队及携程、去哪儿两大OTA巨头的大数据和流量支持，致力于成为最值得信赖的目的旅游服务品牌，为消费者提供旅游度假中的「吃住行，游购娱」360°全方位服务。<br/><br/>旅悦集团旨在将互联网创新技术应用于传统旅游产业，实现传统行业的数据化、科技化、品牌化、专业化发展，旗下拥有：<br/><br/>全球品质民宿酒店——花筑<br/>高端酒店及度假村——檀程<br/>标准中端酒店——蔚徕<br/>特色中端酒店——柏纳<br/>经济快捷酒店——索性<br/>印度商务连锁酒店——beu',
      'USA': "Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Sucha <br/>India Economy Hotel - beu",
      'JP': "Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Sucha <br/>India Economy Hotel - beu",
      'KO': "Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Sucha <br/>India Economy Hotel - beu",
      'TH':"Lvyue Group was established in 2016, after incubating inside Qunar.com. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group , served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism. <br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services. <br/><br/>Lvyue Group aims to apply innovative Internet technologies to revolutionize the traditional tourism industry with big data, technology, brand and standardization. <br/><br/>Lvyue Groups brands: <br/>Quality Boutique Hotel - Floral<br/>High-end Hotels and Resorts - Arula<br/>Mid-range Hotel - Vyluk & Urba<br/>Budget Hotel - Sucha <br/>India Economy Hotel - beu",
    },
    groupHope={
      'zh-CN': '我们的愿景',
      'USA': 'Our Vision',
      'JP': '私たちのビジョン',
        'KO': '우리의 비젼',
           'TH':'สัยทัศน์ของเรา',
    },
    groupHopeInfo={
      'zh-CN': '以数据为驱动，打造比肩全球的旅游全产业链服务商。',
      'USA': 'To build the group into a complete supply chain and service provider for the tourism industry, a global leader powered by Big Data',
      'JP': 'データに牽引されたグローバルな同業者に匹敵する、業界全体を網羅するサービスプロバイダーにグループを築くこと。',
        'KO': '데이터를 기반으로하는 글로벌 경쟁 업체와 나란히 업계 전체의 서비스 제공 업체로 그룹을 구축하십시오.',
           'TH':'เพื่อสร้างกลุ่ม บริษัท ให้กลายเป็นผู้ให้บริการทั้งอุตสาหกรรมในแนวหน้าของโลกที่ขับเคลื่อนด้วยข้อมูล',
    },
    groupOurBusiness={
      'zh-CN': '我们的业务',
      'USA': 'Our Business',
      'JP': '私たちのビジネス',
        'KO': '우리 사업',
             'TH':'ธุรกิจของเรา',
    },
    groupIntegrateType1={
      'zh-CN': '布草及周边 产品零售',
      'USA': 'Hotel linen & amenities sales',
      'JP': 'ラインとサイドライン、製品小売',
        'KO': '라인 및 사이드 라인, 제품 소매',
          'TH':'จำหน่ายปลีกและส่งสินค้าด้านข้าง',
    },
    groupIntegrateType2={
      'zh-CN': '酒店PMS 管理系统',
      'USA': 'Hotel PMS (Property Management System)',
      'JP': 'ホテルPMS管理システム',
        'KO': '호텔 PMS 관리 시스템',
              'TH':'ระบบการจัดการโรงแรม PMS',
    },
    groupIntegrateType3={
      'zh-CN': '酒店管理 培训学校',
      'USA': 'Hotel Management Training School',
      'JP': 'ホテル管理、トレーニングスクール',
        'KO': '호텔 경영, 교육 학교',
             'TH':'การจัดการโรงแรม, โรงเรียนฝึกอบรม',
    },
    groupIntegrateType4={
      'zh-CN': '酒店CRS 管理系统',
      'USA': 'Hotel CRS (Central Reservation System)',
      'JP': 'ホテルCRS管理システム',
        'KO': '호텔 CRS 관리 시스템',
            'TH':'ระบบการจัดการโรงแรม CRS',
    },
    groupIntegrateType5={
      'zh-CN': '旅悦致品 线上商城',
      'USA': 'LvYue Selections e-commerce shop',
      'JP': 'LvYueセレクション、オンラインモール',
        'KO': 'LvYue Selections, 온라인 몰',
          'TH':'ตัวเลือก LvYue, ห้างสรรพสินค้าออนไลน์',
    },
    groupIntegrateType6={
      'zh-CN': '纺织品<br>洗涤租赁',
      'USA': 'Linen Laundry Service',
      'JP': '洗濯＆リース',
        'KO': '세탁 및 임대',
          'TH':'ซักผ้า & ลีสซิ่ง',
    },
    groupIntegrateType7={
      'zh-CN': '洗涤租赁',
      'USA': 'Washing& Leasing',
      'JP': '',
        'KO': '',
          'TH':'',
    },
    groupCoreCompetitiveness={
      'zh-CN': '我们的核心竞争力',
      'USA': 'Core Advantages',
      'JP': 'コア競争力',
        'KO': '핵심 경쟁력',
          'TH':'ความสามารถในการแข่งขันหลัก',
    },
    groupIntegrate2Type1={
      'zh-CN': '携程控股',
      'USA': 'Strategic Holdings by Ctrip',
      'JP': 'シートリップによる戦略的保有物',
        'KO': 'Ctrip에 의한 전략적 홀딩스',
          'TH':'การถือครองเชิงกลยุทธ์โดย Ctrip',
    },
    groupIntegrate2Type2={
      'zh-CN': '互联网创新基因',
      'USA': 'Internet Innovation',
      'JP': 'インターネットイノベーションの強み',
        'KO': '인터넷 혁신 강점',
          'TH':'จุดแข็งของนวัตกรรมอินเทอร์เน็ต',
    },
    groupIntegrate2Type3={
      'zh-CN': '去哪儿网并肩支持',
      'USA': 'Support by Qunar',
      'JP': 'Qunarによるサポート',
        'KO': 'Qunar의 지원',
          'TH':'สนับสนุนโดย Qunar',
    },
    group_container_middle1_detail4_1={
      'zh-CN': '强大的互联网用户数据支撑',
      'USA': 'Powered by Big Data',
      'JP': 'ビッグデータを搭載',
        'KO': '큰 데이터로 구동',
          'TH':'ขับเคลื่อนโดยข้อมูลขนาดใหญ่',
    },
    group_container_middle1_detail4_2={
      'zh-CN': '分析用户消费行为轨迹及偏好',
      'USA': 'Guest Consumption Behaviour Analysis',
      'JP': 'ゲスト消費行動分析',
        'KO': '고객 소비 행동 분석',
          'TH':'การวิเคราะห์พฤติกรรมการบริโภคของแขก',
    },
    group_container_middle1_detail4_3={
      'zh-CN': '数据驱动运营管理',
      'USA': 'Data-driven Management',
      'JP': 'データ駆動型管理',
        'KO': '데이터 기반 관리',
          'TH':'การจัดการข้อมูลที่ขับเคลื่อนด้วย',
    },
    group_container_middle1_detail5_1={
      'zh-CN': '精准市场营销及管理等资源配置',
      'USA': 'Targeted Marketing',
      'JP': 'ターゲットマーケティング',
        'KO': '타겟 마케팅',
          'TH':'การตลาดเป้าหมาย',
    },
    group_container_middle1_detail5_2={
      'zh-CN': '资源利用及效率提升最大化',
      'USA': 'Maximizing Resource Utilisation',
      'JP': 'リソース利用率の最大化',
        'KO': '자원 활용 극대화',
          'TH':'การใช้ทรัพยากรให้เกิดประโยชน์สูงสุด',
    },
    groupBigData={
      'zh-CN': '携手大数据 — 拥抱互联网',
      'USA': 'Tapping into Big Data and powered by the Internet ',
      'JP': 'ビッグデータを活用してインターネットを受け入れる',
        'KO': '큰 데이터 활용 및 인터넷 포용',
           'TH':'แตะที่ข้อมูลขนาดใหญ่และเปิดอินเทอร์เน็ต',
    },
    groupTeamContant={
      'zh-CN': '旅悦集团基于携程、去哪儿海量用户数据，以用户消费数据判断用户需求、以数据驱动运营管理，以技术驱动系统服务、以需求带动产业链规划建设。同时，配以去哪儿网+海底捞高管团队，线上+线下双引擎驱动酒店业升级，打造智能化、定制化的整体解决方案。',
      'USA': 'Based on massive amounts of user data from Ctrip and Qunar, LvYue Group identifies user needs and user consumption data to drive management and operations, advance system services with technology, and enhance industry supply chain planning & construction demands.<br/>LvYue benefits from the experience of Qunar\'s core leadership, as well as senior level executives from HaiDiLao. The combination of strong leadership from online and offline service industries drives new smart solutions for hotels.',
      'JP': 'CtripとQnarの膨大なユーザーデータに基づいて、LvYue Groupはユーザーニーズを特定し、ユーザー消費データを使用して管理と運用を推進し、システムサービスをテクノロジで進め、さらに業界チェーンプランニングと需要の構築を促進します。その間、それはHaiDiLaoからのQunar +上級幹部の中心的なリーダーシップを利用します。オンライン+オフラインの最上位チームがホテル業界のアップグレードを推進し、目的地のホテル向けにスマートでカスタマイズされたパッケージソリューションを提供します。',
        'KO': 'Ctrip 및 Qnar의 대규모 사용자 데이터를 기반으로하는 LvYue Group은 사용자 요구를 파악하고 사용자 소비 데이터로 관리 및 작동을 유도하고 기술로 시스템 서비스를 발전 시키며 요구 사항이있는 산업 체인 계획 및 건설에 박차를가합니다. 한편, Qunar의 핵심 리더십 + HaiDiLao의 임원진을 활용합니다. 온라인 + 오프라인 최상위 팀은 호텔 업계 업그레이드를 추진하고 목적지 호텔에 스마트하고 맞춤화 된 패키지 솔루션을 제공합니다.',
               'TH':'จากข้อมูลผู้ใช้จำนวนมากจาก Ctrip และ Qnar กลุ่ม LvYue ระบุความต้องการของผู้ใช้และผลักดันการจัดการและการดำเนินงานด้วยข้อมูลการใช้ของผู้ใช้บริการระบบขั้นสูงด้วยเทคโนโลยีและกระตุ้นการวางแผนห่วงโซ่อุตสาหกรรมและการก่อสร้างตามความต้องการ ในขณะเดียวกันก็ยกระดับความเป็นผู้นำหลักของ Qunar + ผู้บริหารระดับสูงจาก HaiDiLao ทีมระดับบนสุดออนไลน์และออฟไลน์ผลักดันการยกระดับอุตสาหกรรมโรงแรมและนำเสนอโซลูชันแพ็คเกจที่ชาญฉลาดและปรับแต่งได้สำหรับโรงแรมปลายทาง',
    },
    groupSingleDimension={
      'zh-CN': '单维度酒店 多维度发展',
      'USA': 'Unitdimensional hotels and multi-dimensional development',
      'JP': '一次元ホテルと多次元開発',
        'KO': 'Unitdimensional 호텔 및 다차원 개발',
             'TH':'โรงแรมแบบมิติและการพัฒนาแบบหลายมิติ',
    },
    groupProgramme={
      'zh-CN': '旅悦集团坚持“链条对链条”的产业链打造方针。在不断完善自身的同时，将酒店衍生产业链如酒店客用品配置与集采、培训学院、用户在线商城等衍生服务做到极致，为酒店业主提供全产业链服务。用户方面，不仅拥有独立运营的在线商城“旅悦致品”，为酒店场景消费提供了“所见即所得”的模式，将线上线下打通，同时还能够为用户提供专属出行定制服务——花筑旅行，360°为客人解决人在旅途中的一切问题。',
      'USA': '360 degree development - From Hotel Operations to Complete Supply Chain<br/>LvYue constantly improves hotels and provides a complete end-to-end hotel management solution through its smart service system named "Butler".<br/>Incubated by LvYue R&D teams, the "Butler" system is a complete set of closed-loop services such as site selection and preparation (Aladdin Hotspot Selection System), group purchasing, hotel operations, cost control,  channel management and customer service (XPMS), talent development and resourcing (LvYue University).<br/>All these systems help to standardise the Group\'s brands and management operations.',
      'JP': '当グループは、産業チェーン構築において「チェーン間」方針を遵守している。絶え間ない自己改善と並行して、ホテルのゲスト用品の構成など、派生的サービスにおける最高の卓越性を目指します。ホテルの業界全体のチェーンサービスを提供するためのグループ購入、トレーニングスクール、ユーザーのオンラインモールなど。ユーザーのために、それは「あなたが見るものはあなたが得るものである」という可能性を顧客に提供する、独立して運営されるオンラインショッピングモール「LvYue Selections」を設立しました。オンラインサービスとオフラインサービスが接続されているため、フローラルトラベルを介してカスタマイズされた旅行サービスをユーザーに提供し、道路上で起こりうるあらゆる問題に対する幅広いソリューションを提供します。',
        'KO': '그룹은 산업 체인 건설에서 "사슬 연쇄"정책을 고수합니다. 끊임없는 자기 개선과 병행하여, 호텔 게스트 용품 구성 및 서비스와 같은 파생 상품에서 최고의 우수성을 위해 노력합니다. 그룹 구매, 교육 학교, 사용자 온라인 쇼핑몰 등을 통해 호텔 업계 전체의 체인 서비스를 제공합니다. 사용자를 위해 독립적으로 운영되는 온라인 쇼핑몰 인 LvYue Selections를 개설하여 고객에게 "귀하가 얻은 바를 보는 것"의 가능성을 제공합니다. 온 라인 및 오프라인 서비스가 연결되어있어 이동 중에 발생할 수있는 모든 문제에 대한 모든 솔루션을 제공하여 Floral Travel을 통해 맞춤식 여행 서비스를 사용자에게 제공합니다.',
              'TH':'กลุ่มปฏิบัติตามนโยบาย“ ห่วงโซ่ต่อห่วงโซ่” ในการก่อสร้างห่วงโซ่อุตสาหกรรม ควบคู่ไปกับการพัฒนาตนเองอย่างไม่หยุดยั้งมันมุ่งมั่นสู่ความเป็นเลิศสูงสุดในการให้บริการตราสารอนุพันธ์เช่นการกำหนดค่าอุปกรณ์ของโรงแรมสำหรับแขก & amp; การซื้อกลุ่มโรงเรียนการฝึกอบรมผู้ใช้ห้างสรรพสินค้าออนไลน์ ฯลฯ เพื่อให้บริการเครือข่ายทั้งอุตสาหกรรมสำหรับโรงแรม สำหรับผู้ใช้มันได้จัดตั้งห้างสรรพสินค้าออนไลน์ที่ดำเนินการอย่างอิสระ“ ตัวเลือก LvYue” เพื่อให้ลูกค้ามีความเป็นไปได้ของ“ สิ่งที่คุณเห็นคือสิ่งที่คุณได้รับ” ด้วยการเชื่อมต่อบริการออนไลน์และออฟไลน์มันยังให้บริการการเดินทางที่กำหนดเองแก่ผู้ใช้ผ่านฟลอรัลทราเวล， ด้วยโซลูชั่นที่ครบวงจรสำหรับทุกปัญหาที่เป็นไปได้บนท้องถนน',
    },
    groupCultureLeads={
      'zh-CN': '企业文化引领发展',
      'USA': 'Corporate culture leads development',
      'JP': '企業文化が開発をリードする',
        'KO': '발전하는 기업 문화',
          'TH':'วัฒนธรรมองค์กรนำไปสู่การพัฒนา',
    },
    groupcultureLeadsInfo={
      'zh-CN': '旅悦集团作为中国酒店和旅游行业最年轻的团队之一，注重企业文化的打造，集团将“消费者第一、合作伙伴第二、员工第三、股东第四”作为第一价值观，鼓励员工“大声说话”，打造员工“激情 敬业 诚实 皮实”的职业性格，秉承“努力赚每一块钱，努力省每一块钱”价值理念，用服务者的姿态迎接每一位消费者，用赢家的气质迎接每一个挑战。',
      'USA': "Corporate Culture Leads Development<br/>LvYue Group, as one of the youngest teams in China‘s hotel and tourist industries, stresses the building of corporate culture. The Group regards “Consumers First, Partners Second, Employees Third, Shareholder Fourth” as its primary mantra. The Group encourages employees to “speak out”, and shapes the professional character of its employees to be “passionate, dedicated, honest, and diligent”. It promotes a message of “earn more & save more” along with its “bulldozer culture”, as well as receiving each customer warmly, and bravely facing new challenges.",
      'JP': 'LvYueグループは、中国のおもてなしと観光業界で最も若いチームの1つとして、企業文化の構築を重視しています。グループはその第一の価値として「消費者第一、パートナー第二、従業員第三、そして株主第四」を考え、従業員を「話す」ことを奨励し、そして「情熱的で、献身的で、誠実かつ不屈」の職業的性格を形成します。それは「各ペニーを稼いで節約するために努力する」という考えを支持し、すべての顧客にサービス精神を与え、そして勝者の考え方で課題に立ち向かいます。',
        'KO': 'LvYue Group은 중국의 환대 및 관광 산업에서 가장 어린 팀 중 하나로서 기업 문화 구축을 중시합니다. 그룹은 \'소비자 우선, 파트너 2 위, 3 위 주주 4 위\'를 기본 가치로 생각하고 직원들에게 \'Speak Up\'을 권장하고 \'정열적이고 헌신적이며 정직하고 불굴의 정신\'이라는 전문적인 인물을 형성합니다. 그것은 \'각 페니를 벌고 저축하기 위해 노력하는\'아이디어를지지하고, 모든 고객에게 서비스 정신을 제공하며, 승자 의식으로 도전에 부딪칩니다.',
           'TH':'กลุ่ม LvYue เป็นหนึ่งในทีมที่อายุน้อยที่สุดในอุตสาหกรรมการบริการและการท่องเที่ยวของจีนให้ความสำคัญกับการสร้างวัฒนธรรมองค์กร กลุ่มมอง \'ผู้บริโภครายแรกหุ้นส่วนที่สองพนักงานที่สามและผู้ถือหุ้นคนที่สี่\' เป็นค่านิยมหลักส่งเสริมให้พนักงาน \'พูดขึ้น\' และกำหนดรูปแบบอาชีพของพวกเขาในการเป็น \'ความมุ่งมั่นทุ่มเทซื่อสัตย์และไม่ย่อท้อ\' มันเป็นความคิดที่ว่า \'พยายามที่จะได้รับและประหยัดเงิน\' ได้รับการบริการลูกค้าอย่างเต็มที่และยืนหยัดเพื่อความท้าทายด้วยความคิดที่ชนะ',
    },
    payNewsPaidInformation={
      'zh-CN': '付费资讯',
      'USA': 'Paid Information',
      'JP': '',
        'KO': '',
          'TH':'',
    },
    payNewsTitle1={
      'zh-CN': '出境游预订酒店应该注意什么？才能少些“囧途”',
      'USA': 'What should I pay attention to about booking a hotel for outbound travel?  How could I reduce "setbacks" on the way？',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    payNewsTitle2={
      'zh-CN': '杭州考研住宿：住宿的几个建议要牢牢记住！',
      'USA': 'Hangzhou Accommodation for Graduate-study admission exam: Several tips for accommodation should be kept in mind!',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    payNewsTitle3={
      'zh-CN': '酒店民宿or别墅？引领出境游住宿新风尚',
      'USA': 'B&B  Hotel or Villa? Leading the new style of outbound travel accommodation',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    payNewsTitle4={
      'zh-CN': '为什么酒店的数据最容易“偷”',
      'USA': "Why a hotel's data is motly inclined to be 'stolen'?",
      'JP': '',
        'KO': '',
          'TH':'',
    },
    payNewsTitle5={
      'zh-CN': '入乡随俗：外国住酒店，哪些潜规则需注意？',
      'USA': 'As the Romans do: What unspoken rules should be noted when staying at a hotel abroad?',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    payNewsTitle6={
      'zh-CN': '酒店“非典型”场景革命：AI如何引领“造梦空间”？',
      'USA': "Hotel's 'atypical'scene revolution: How does AI lead the 'dream workshop'?",
      'JP': '',
        'KO': '',       'TH':'',
    },
    payNewsTitle7={
      'zh-CN': '你的酒店：能保证让客人睡个好觉吗？',
      'USA': 'Could you assure the guest a sound sleep?',
      'JP': '',
        'KO': '',       'TH':'',
    },
    payNewsTitle8={
      'zh-CN': '传统酒店如何跨界“掘金”，旅悦信息给出了更优解',
      'USA': "How traditional hotels cross the border to 'dig gold'? There is a better solution in LvYue's information.",
      'JP': '',
        'KO': '',       'TH':'',
    },
    payNewSTips1={
      'zh-CN': '微信支付二维码有效时长为5分钟，请尽快支付',
      'USA': 'WeChat payment QR code is valid for 5 minutes, please pay ASAP.',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    payNewSTips2={
      'zh-CN': '请使用微信扫一扫 扫描二维码支付',
      'USA': 'Please scan QR codein WeChat to pay.',
      'JP': '',
        'KO': '',
            'TH':'',
    },
    flowerBuildingTitle={
      'zh-CN': '花筑酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'Floral',
      'JP': '花築ホテル、旅館、民宿ブランドの紹介-ホテルハイアットの公式サイト',
        'KO': '꽃축 호텔, 여인숙, 펜션브랜드 소개 - 나야트그룹 공식 홈페이지',
        'TH':' โรงแรม Huazhu, Inn, B & B แบรนด์บทนำ - เว็บไซต์อย่างเป็นทางการ Lvyue Group',
    },
    flowerBuildingDesign={
      'zh-CN': '花筑设计理念',
      'USA': 'Design Philosophy of Floral Hotel',
      'JP': 'フローラルホテルのデザイン哲学',
        'KO': '플로랄 호텔의 디자인 철학',
            'TH':'ปรัชญาการออกแบบโรงแรมดอกไม้',
    },
    flowerBuildingDesignType1={
      'zh-CN': '质感',
      'USA': 'Quality',
      'JP': '品質',
        'KO': '품질',
            'TH':'คุณภาพ',
    },
    flowerBuildingDesignType2={
      'zh-CN': '关怀',
      'USA': 'Care',
      'JP': 'ケア',
        'KO': '케어',
            'TH':'การดูแล',
    },
    flowerBuildingDesignType3={
      'zh-CN': '智能',
      'USA': 'Intelligence',
      'JP': '知能',
        'KO': '지성',
          'TH':'สติปัญญา',
    },
    flowerBuildingaboutfb={
      'zh-CN': '花筑·品牌介绍',
      'USA': 'Floral Hotel-Brand Introduction',
      'JP': 'フローラルホテル - ブランドの紹介',
        'KO': '플로럴 호텔 - 브랜드 소개',
          'TH':'แนะนำโรงแรมแบรนด์ฟลอรัล',
    },
    flowerBuildingaboutfbType1={
      'zh-CN': '精品度假酒店',
      'USA': 'Scenic Boutique Hotels & Resorts',
      'JP': 'ブティックホリデイズホテルズ＆リゾーツ',
        'KO': '부티크 휴일 호텔 & 리조트',
          'TH':'โรงแรมและรีสอร์ทบูติคฮอลิเดย์',
    },
    flowerBuildingaboutfbType2={
      'zh-CN': '花筑在全球范围内甄选极致风景。\<br>' +
          '隐藏在古镇，坐落在山间或湖边，花筑集合一系列独一无二的风景。每一家都融合了在地文化、设计&氛围，用热情、温暖、个性化的服务欢迎每一位游客。',
      'USA': "Floral Hotel selects the most splendid sceneries in every corner of the world.<br/> Hidden in an old town, secluded on a mountain side or lake shore, the brand gathers a collection of unique addresses. Each hotel combines local cultures, design & atmosphere to welcome travellers with emotion and a warm personalised service. ",
      'JP': '山側や湖岸に人里離れた旧市街に隠されたこのブランドは、ユニークな住所のコレクションを集めています。 各ホテルは地元の文化、デザイン、雰囲気を兼ね備え、感情と温かい行き届いたサービスでお客様をお迎えします。',
        'KO': '산 쪽 또는 호숫가에 외딴 구시 가지에 숨어있는이 브랜드는 고유 한 주소 모음을 수집합니다. 각 호텔은 지역 문화, 디자인 및 분위기를 결합하여 감정과 따뜻한 맞춤 서비스로 여행객을 환영합니다.',
           'TH':'ซ่อนตัวอยู่ในเมืองเก่าที่เงียบสงบบนภูเขาหรือฝั่งทะเลสาบแบรนด์รวบรวมชุดของที่อยู่ที่ไม่ซ้ำกัน โรงแรมแต่ละแห่งผสมผสานวัฒนธรรมท้องถิ่นการออกแบบและบรรยากาศเพื่อต้อนรับนักท่องเที่ยวด้วยอารมณ์และบริการที่อบอุ่นเป็นส่วนตัว',
    },
    flowerBuildingaboutfbType3={
      'zh-CN': '一花一世界 一筑一生活',
      'USA': "Embrace local originality.",
      'JP': '地元のオリジナリティを取り入れる',
        'KO': '현지 독창성을 받아들입니다.',
           'TH':'โอบกอดความคิดริเริ่มในท้องถิ่น',
    },
    flowerBuildingBrand1={
      'zh-CN': '花 筑 · 奢',
      'USA': 'Floral-Lux',
      'JP': 'フローラルラックス',
        'KO': '꽃 - 럭스',
           'TH':'Floral-Lux',
    },
    flowerBuildingBrand2={
      'zh-CN': '花 筑',
      'USA': 'Floral',
      'JP': 'フローラル',
        'KO': '플로랄',
              'TH':'ดอกไม้',
    },
    flowerBuildingBrand3={
      'zh-CN': '花 筑 · 悦',
      'USA': 'Floral-Joy',
      'JP': 'フローラルジョイ',
        'KO': '꽃 - 기쁨',
            'TH':'ดอกไม้จอย',
    },
    flowerBuildingBrand4={
      'zh-CN': '花 筑 · 城市',
      'USA': 'Floral-City',
      'JP': '',
        'KO': '',       'TH':'',
    },
    flowerBuildingBrand1Info={
      'zh-CN': '高端精品酒店',
      'USA': 'High-end Boutique Hotel',
      'JP': 'ハイエンドブティックホテル',
        'KO': '하이 엔드 부티크 호텔',
            'TH':'โรงแรมบูติกระดับสูง',
    },
    flowerBuildingBrand1Introduction={
      'zh-CN': '以7感为核心，为住客提供一对一管家，体验定制化服务',
      'USA': 'Caring for guests with our \'7 senses\' service philosophy, we immerse our travellers in luxury, including a one-to-one butler service and customised experiences',
      'JP': '7つの感覚をコアにして、私たちは一対一の執事とカスタマイズされた経験サービスをお客様に提供します。',
        'KO': '7 가지 감각을 토대로 손님에게 일대일 버틀러 및 맞춤형 체험 서비스를 제공합니다.',
            'TH':'เราให้บริการบัตเลอร์แบบหนึ่งต่อหนึ่งและบริการประสบการณ์ตามความต้องการ',
    },
    flowerBuildingBrand3Info={
      'zh-CN': '经济舒适酒店',
      'USA': 'Economic Comfort Hotel',
      'JP': 'エコノミックコンフォートホテル',
        'KO': '이코노미 컴포트 호텔',
          'TH':'โรงแรมคอมฟอร์ทคอมฟอร์ท',
    },
    flowerBuildingBrand3Introduction={
      'zh-CN': '以经济高品质服务为核心，为住客打造舒适高性价比的入住体验',
      'USA': 'Coring on high quality service, create comfortable and cost-effective stay experience for  guests.',
      'JP': '質の高いサービスを心がけ、快適で費用対効果の高い滞在をご体験ください。',
        'KO': '고품질의 서비스를 제공하여 편안하고 비용 효율적인 숙박 경험을 제공합니다.',
         'TH':'การให้บริการที่มีคุณภาพสูงสร้างประสบการณ์การเข้าพักที่สะดวกสบายและคุ้มค่าสำหรับแขก',
    },
    flowerBuildingBrand2Info={
      'zh-CN': '高端精品酒店',
      'USA': 'High-end Boutique Hotel',
      'JP': '',
        'KO': '',       'TH':'',
    },
    flowerBuildingBrand2Introduction={
      'zh-CN': '融入当地文化，传承人文，依托自然，给住客带来一种放慢身心，静享时光流逝的生活方式',
      'USA': 'Fitting into local culture, inheriting humanism, relying on nature, bringing guest a lifestyle to relax their bodies and minds and enjoy the passage of time',
      'JP': '地元の文化にフィットし、ヒューマニズムを継承し、自然に頼り、体と心をリラックスさせ、時間の経過を楽しむライフスタイルをゲストにもたらします',
        'KO': '지역 문화에 적응하고, 인본주의를 이어받으며, 자연에 의지하며, 손님들의 몸과 마음을 편안하게하고 시간의 흐름을 즐기는 라이프 스타일을 가져옵니다.',
              'TH':'ปรับให้เข้ากับวัฒนธรรมท้องถิ่นสืบทอดความเป็นมนุษย์นิยมอาศัยธรรมชาตินำวิถีชีวิตของแขกมาพักผ่อนเพื่อผ่อนคลายร่างกายและจิตใจและเพลิดเพลินไปกับกาลเวลา',
    },
    flowerBuildingBrand4Info={
      'zh-CN': '高端都市酒店',
      'USA': 'High-end city hotel',
      'JP': '',
        'KO': '',
          'TH':'',
    },
    flowerBuildingBrand4Introduction={
      'zh-CN': '以简约富有品质的设计理念，旨在为年轻出行者提供休闲、时尚、精致的住宿体验',
      'USA': 'Designed with simplicity and quality to provide young travelers with a casual, stylish and sophisticated experience.',
      'JP': '',
        'KO': '',
            'TH':'',
    },
    flowerBuildingSenseTitle={
      'zh-CN': '打造非标住宿的服务标杆——七感服务',
      'USA': 'The new benchmark for unique accomodation - Seven-sense services',
      'JP': '非標準的な宿泊施設のベンチマークを設定します -  7センスサービス',
        'KO': '비표준 편의 시설에 대한 벤치 마크 설정 - 일곱 가지 감지 서비스',
             'TH':'กำหนดมาตรฐานสำหรับที่พักที่ไม่ได้มาตรฐาน - บริการของเซเว่นเซ้นส์',
    },
    flowerBuildingSixFeeling1={
      'zh-CN': '视觉感',
      'USA': 'Sight',
      'JP': 'ビジュアル',
        'KO': '비쥬얼',
          'TH':'ภาพ',
    },
    flowerBuildingSixFeeling2={
      'zh-CN': '听觉感',
      'USA': 'Sound',
      'JP': '聴覚',
        'KO': '듣기',
           'TH':'การได้ยิน',
    },
    flowerBuildingSixFeeling3={
      'zh-CN': '味觉感',
      'USA': 'Taste',
      'JP': '味',
        'KO': '미각',
           'TH':'ลิ้มรส',
    },
    flowerBuildingSixFeeling4={
      'zh-CN': '触觉感',
      'USA': 'Touch',
      'JP': 'タッチ',
        'KO': '접촉',
            'TH':'แตะ',
    },
    flowerBuildingSixFeeling5={
      'zh-CN': '嗅觉感',
      'USA': 'Scent',
      'JP': '匂い',
        'KO': '냄새',
           'TH':'กลิ่น',
    },
    flowerBuildingSixFeeling6={
      'zh-CN': '参与感',
      'USA': 'Participation',
      'JP': '参加',
        'KO': '참여',
            'TH':'การมีส่วนร่วม',
    },
    flowerBuildingSixFeeling7={
      'zh-CN': '回忆感',
      'USA': 'Memory',
      'JP': '記憶',
        'KO': '기억',
           'TH':'หน่วยความจำ',
    },
    flowerBuildingSixFeeling1Info={
      'zh-CN': '硬装设计、软装搭配、品牌月刊、接机着装',
      'USA': 'Fit-out design, soft outfit collocation, brand monthly, pick-up dressing',
      'JP': '',
        'KO': '',
            'TH':'',
    },
    flowerBuildingSixFeeling2Info={
      'zh-CN': '背景音乐、智能音箱、隔音处理、暖心服务',
      'USA': 'Background music, Intelligent speakers, sound insulation, heartwarming service',
      'JP': '',
        'KO': '',
            'TH':'',
    },
    flowerBuildingSixFeeling3Info={
      'zh-CN': '迎客奉茶、免费小食、晚归膳暖、美食地图、咖啡茶包',
      'USA': 'Welcome tea, free snacks, late meal, food map, coffee/tea bag',
      'JP': '',
        'KO': '',       'TH':'',
    },
    flowerBuildingSixFeeling4Info={
      'zh-CN': '优质布草、物品摆放、星级床垫、优选枕头、热水足浴、品质面膜',
      'USA': 'Quality linen, article arrangement, star-rated mattress, selected pillows, foot bath and quality masks.',
      'JP': '',
        'KO': '',       'TH':'',
    },
    flowerBuildingSixFeeling5Info={
      'zh-CN': '香薰系统、除臭系统、新风系统',
      'USA': 'Fragrance system, Deodorization system and Fresh air system',
      'JP': '',
        'KO': '',
         'TH':'',
    },
    flowerBuildingSixFeeling6Info={
      'zh-CN': '影像画廊、自助厨房、产品体验、主题活动',
      'USA': 'Images gallery, self-service kitchen, product experience, theme activities.',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    flowerBuildingSixFeeling7Info={
      'zh-CN': '时光胶囊、点评互动、问候短信、伴手礼物',
      'USA': 'Time capsule, comments& interaction, hello message, gifts',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    simplyTitle={
      'zh-CN': '索性酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'SuoXing Hotel –Floral Travel',
      'JP': 'いっそのホテル、旅館、民宿ブランドの紹介-ホテルハイアットの公式サイト',
        'KO': '머나먼 호텔, 펜션브랜드 소개 - 나야트그룹 공식 홈페이지',
           'TH':'Suo Hotel, Inn, B & B บทนำของแบรนด์ - เว็บไซต์อย่างเป็นทางการ Lvyue Group Keywords: Suo Hotel, Suo Inn, Suo B & B แนวคิดการออกแบบที่เรียบง่ายเพียงแค่แบรนด์',
    },
    simplyDesign={
      'zh-CN': '索性设计理念',
      'USA': 'Design Philosophy of Suoxing Hotel',
      'JP': 'Suoxing Hotelのデザイン哲学',
        'KO': 'Suoxing Hotel의 디자인 철학',
          'TH':'ปรัชญาการออกแบบของโรงแรมซู่ซิง',
    },
    simplyDesignType1={
      'zh-CN': '年轻',
      'USA': 'Comfort ',
      'JP': '青少年',
        'KO': '청소년',
           'TH':'หนุ่ม',
    },
    simplyDesignType2={
      'zh-CN': '创意',
      'USA': 'Enthusiasm',
      'JP': '創造性',
        'KO': '창의력',
          'TH':'ความคิดสร้างสรรค์',
    },
    simplyDesignType3={
      'zh-CN': '活力',
      'USA': 'Creativity',
      'JP': '活力',
        'KO': '활력',
          'TH':'พลัง',
    },
    simplyBrandIntroductionTitle={
      'zh-CN': '索性·品牌介绍',
      'USA': 'Suoxing Hotel-Brand Introduction',
      'JP': 'Suoxing Hotelブランドの紹介',
        'KO': '쑤싱 호텔 - 브랜드 소개',
           'TH':'แนะนำโรงแรมแบรนด์ Suoxing',
    },
    simplyBrandIntroductionInfo={
      'zh-CN': '索性是旅悦集团旗下轻质连锁酒店品牌。索性以“净，如索性”为品牌理念，深度关注用户对于酒店洁净方面的核心诉求，为快节奏的城市客人提供整洁、舒适的住宿体验。索性细分为索性酒店、索性精选两个系列。',
      'USA': 'You are here for a good night\'s sleep. That’s why all our guestrooms combine simplicity, quality and convenience, inviting you into a comfortable, safe and immaculate environment. While each hotel harbours its own unique design, all deliver the same high quality service and polished décor at a great price. Couples or singles, on business or leisure, our teams welcome everybody with enthusiasm and care.',
      'JP': 'Suoxing HotelはLvYue Groupに所属する軽鎖ホテルブランドです。 それは、「清潔さを追求するホテルとして」のブランド哲学を遵守し、清潔さに対するコアユーザーの要求を非常に重要視し、清潔で快適な宿泊経験をペースの速い都会のゲストに提供します。 Suoxing HotelはSuoxing HotelとSuoxing Hotel Sに分類されます。',
        'KO': 'Suoxing Hotel은 LvYue Group 아래의 경쇄 호텔 브랜드입니다. "As Clean As Suoxing Hotel"이라는 브랜드 철학을 유지하고 청결에 대한 핵심 사용자 요구를 중요하게 생각하며 쾌적하고 쾌적한 숙박 경험을 제공하는 쾌적한 도시인을 제공합니다. Suoxing Hotel은 Suoxing Hotel과 Suoxing Hotel S로 분류됩니다.',
           'TH':'Suoxing Hotel เป็นโรงแรมในเครือแสงภายใต้กลุ่ม LvYue มันยึดถือปรัชญาของแบรนด์ "As As As As Suoxing Hotel" ให้ความสำคัญอย่างยิ่งกับความต้องการหลักของผู้ใช้เพื่อความสะอาดและให้ผู้เข้าพักในเมืองอย่างรวดเร็วด้วยประสบการณ์ที่พักที่สะอาดและสะดวกสบาย Suoxing Hotel แบ่งออกเป็น Suoxing Hotel และ Suoxing Hotel S.',
    },
    simplyBrand1={
      'zh-CN': '索性精选',
      'USA': 'Suoxing Hotel S',
      'JP': 'スチャホテルS',
        'KO': 'Suoxing 호텔 S',
         'TH':'โรงแรมซู่ซิง',
    },
    simplyBrand2={
      'zh-CN': '索性',
      'USA': 'Suoxing Hotel ',
      'JP': 'サックス',
        'KO': 'Suoxing',
         'TH':'Suoxing',
    },
    simplyBrand1Introduction={
      'zh-CN': '空间升级、视觉升级、服务升级、舒适与品质一样都不能少。',
      'USA': 'Upgrading of space, vision and service,  comfort and quality are indispensable.',
      'JP': 'スペース、ビジョンとサービス、快適さと品質の向上は不可欠です。',
        'KO': '공간, 비전 및 서비스, 편안함 및 품질의 업그레이드는 필수 불가결합니다.',
            'TH':'การอัพเกรดพื้นที่วิสัยทัศน์และบริการความสะดวกสบายและคุณภาพเป็นสิ่งที่ขาดไม่ได้',
    },
    simplyBrand2Introduction={
      'zh-CN': '以洁净舒适为中心，为住客提供超高性价比的住宿体验。',
      'USA': 'Centering on cleanliness and comfort, we offer our guests super-high cost-effective stay experience.',
      'JP': '清潔さと快適さを中心に、我々はお客様に超高コスト効果の高い滞在体験を提供します。',
        'KO': '청결 함과 편안함을 중심으로 우리는 손님에게 초고 비용 대비 효과적인 숙박 경험을 제공합니다.',
         'TH':'ด้วยความสะอาดและความสะดวกสบายเรามอบประสบการณ์การเข้าพักที่คุ้มค่าที่สุด',
    },
    WeiLaiTitle={
      'zh-CN': '蔚徕酒店、客栈、民宿品牌介绍-旅悦集团官网',
      'USA': 'Vyluk Hotel',
      'JP': 'ホテル、旅館、民宿ブランドの紹介-ホテルハイアットの公式サイト',
        'KO': '호텔, 펜션 브랜드 소개 - 나트위그룹 홈페이지',
            'TH':'Weihao Hotel, Inn, B & B บทนำของแบรนด์ - เว็บไซต์อย่างเป็นทางการของกลุ่ม Lv Yue',
    },
    WeiLaiDesign={
      'zh-CN': '蔚徕设计理念',
      'USA': 'Design Philosophy of Vyluk Hotel ',
      'JP': 'Vyluk Hotelのデザイン哲学',
        'KO': 'Vyluk Hotel의 디자인 철학',
           'TH':'ปรัชญาการออกแบบของโรงแรม Vyluk',
    },
    WeiLaiDesignType1={
      'zh-CN': '时尚',
      'USA': 'Fashion',
      'JP': 'ファッション',
        'KO': '유행',
          'TH':'แฟชั่น',
    },
    WeiLaiDesignType2={
      'zh-CN': '品质',
      'USA': 'Quality',
      'JP': '品質',
        'KO': '품질',
            'TH':'คุณภาพ',
    },
    WeiLaiDesignType3={
      'zh-CN': '共享',
      'USA': 'Sharing',
      'JP': '共有する',
        'KO': '나누는',
            'TH':'ที่ใช้ร่วมกัน',
    },
    WeiLaiBrandIntroductionTitle={
      'zh-CN': '蔚徕·品牌介绍',
      'USA': 'Vyluk Hotel -Brand Introduction',
      'JP': 'Vyluk Hotel  - ブランド総合案内',
        'KO': '빌럭 호텔 - 브랜드 소개',
           'TH':'Vyluk Hotel - แนะนำแบรนด์โดยย่อ',
    },
    WeiLaiBrandIntroductionInfo={
      'zh-CN': '为满足⽤户个性化、品质化、多元化、社交化、共享化等多维度的入住需求，Vyluk蔚徕酒店遴选城市核心地块，塑造城市酒店新风向。\n' +
          '设计上，注重⽣活⽅式的营造与细节的打磨，不仅为客人在客房提供安眠、影⾳音及舒适的空间体验，同时酒店公共空间可以实现多功能转换，不仅有效提高空间的利用性，更实现了生活与酒店共享空间的完美集合。\n' +
          '链接一切美好，以不凡见未来',
      'USA': 'Based in city hotspots, Vyluk is a new style of urban hotel, welcoming guests who seek more than just a cosy room and restaurant. Innovative and tech-friendly, with multifunctional, convertible spaces designed for a versatile lifestyle, Vyluk Hotels provide practical, clean, comfortable and convivial environments for creative meetings, relaxation and social gatherings.',
      'JP': '都市のホットスポットに基づいて、Vylukは居心地の良い部屋やレストラン以上のものを求めるお客様を歓迎都市のホテルの新しいトレンドです。革新的で、技術に優しく、そして多機能なコンバーチブルスペースは、多様なライフスタイルのために想像されます。Vylukホテルでは、創造的な会議、リラクゼーション、社交的な集まりをお探しの方に実用的で清潔で快適で陽気な環境を提供しています。',
        'KO': 'Vyluk은 도시의 핫 스폿을 기반으로 아늑한 객실과 레스토랑을 찾는 손님을 환영하는 도시형 호텔의 새로운 트렌드입니다. 혁신적이고 기술 친화적 인 다기능 컨버터블 공간은 다양한 라이프 스타일을 상상합니다.Vyluk 호텔은 창조적 인 회의, 휴식 또는 사교 모임을 찾는 사람들에게 실용적이고 깨끗하며 편안하고 상냥한 환경을 제공합니다.',
           'TH':'Vyluk ตั้งอยู่ในจุดร้อนของเมืองเป็นเทรนด์ใหม่ของโรงแรมในเมืองที่ต้อนรับแขกที่กำลังมองหามากกว่าห้องพักและร้านอาหารที่สะดวกสบาย นวัตกรรมช่องว่างที่เปลี่ยนแปลงได้เป็นมิตรกับเทคโนโลยีและมัลติฟังก์ชั่นได้รับการจินตนาการสำหรับไลฟ์สไตล์ที่หลากหลาย โรงแรม Vyluk จัดหาสภาพแวดล้อมที่สะอาดสะดวกสบายและสนุกสนานสำหรับผู้ที่มองหาการประชุมสร้างสรรค์การพักผ่อนหรือการสังสรรค์ทางสังคม',
    },
    WeiLaiCorevalueTitle={
      'zh-CN': '服务核心价值',
      'USA': 'Core Service Values',
      'JP': 'コアサービスの価値',
        'KO': '핵심 서비스 값',
           'TH':'ค่าบริการหลัก',
    },
    WeiLaiCorevalueIntroduction={
      'zh-CN': '以舒适、好客、物超所值为使命，为每一位客人打造友好的服务、整洁的客房、舒适亲切的环境。',
      'USA': 'Our mission is to provide comfort, hospitality and value for money, with tailored friendly service, clean rooms and comfortable environments for every guest.',
      'JP': '快適さ、おもてなし、そして金銭的価値観を使命とし、私たちはフレンドリーなサービス、清潔な部屋そして快適な環境をお客様に提供します。',
        'KO': '편안함과 환대, 그리고 가치있는 임무로서 우리는 친절한 서비스, 청결한 객실 및 모든 손님을위한 편안한 환경을 제공합니다.',
           'TH':'ด้วยความสะดวกสบายการต้อนรับและความคุ้มค่าในฐานะภารกิจเราให้บริการที่เป็นมิตรห้องพักสะอาดและสภาพแวดล้อมที่สะดวกสบายสำหรับแขกทุกคน',
    },
    WeiLaiDifference={
      'zh-CN': '四维差异化客房标准',
      'USA': 'Room experience  ',
      'JP': '4次元差別化ルームスタンダード',
        'KO': '4 차원 차별화 된 객실 표준',
           'TH':'มาตรฐานห้องที่ต่างกันสี่มิติ',
    },
    WeiLaiDifference1={
      'zh-CN': '温馨的客房空间',
      'USA': 'Cozy atmopshere',
      'JP': '居心地の良い部屋スペース',
        'KO': '아늑한 룸 공간',
          'TH':'ห้องพักที่สะดวกสบาย',
    },
    WeiLaiDifference2={
      'zh-CN': '极致的影音体验',
      'USA': 'High Speed WiFi',
      'JP': '究極のビジュアルオーディオ体験',
        'KO': '최고의 시각적 오디오 경험',
           'TH':'สุดยอดประสบการณ์ภาพและเสียง',
    },
    WeiLaiDifference3={
      'zh-CN': '高速的无线网络',
      'USA': 'Comfortable bed',
      'JP': '高速無線ネットワーク',
        'KO': '고속 무선 네트워크',
           'TH':'เครือข่ายไร้สายความเร็วสูง',
    },
    WeiLaiDifference4={
      'zh-CN': '舒适的深度睡眠',
      'USA': '',
      'JP': 'サウンドディープスリープ',
        'KO': '소리 깊은 수면',
            'TH':'เสียงหลับสนิท',
    },
    WeiLaiDifference5={
      'zh-CN': '别致酒店套餐',
      'USA': 'Versatile hotel experience',
      'JP': 'シックホテルパッケージ',
        'KO': '칙 호텔 패키지',
            'TH':'แพ็คเกจโรงแรมสุดชิค',
    },
    WeiLaiDifference5Info={
      'zh-CN': '精致的多功能复合大厅，涵盖餐厅、工作休闲、小型会议等功能。自助洗衣房方便顾客的洗衣需求。',
      'USA': 'Exquisite multi-purpose hall, restaurants, work and leisure space, small conference rooms',
      'JP': 'レストラン、仕事やレジャー、小規模の会議やその他の機能をカバーする絶妙な多目的ホール。 ランドリーのニーズに対応するセルフサービスのランドリールーム。',
        'KO': '레스토랑, 업무 및 레저, 소규모 회의 및 기타 기능을 다루는 절묘한 다목적 홀; 셀프 서비스 세탁실을 갖추고 있습니다.',
           'TH':'ห้องโถงอเนกประสงค์ที่งดงามครอบคลุมร้านอาหารงานและการพักผ่อนการประชุมขนาดเล็กและฟังก์ชั่นอื่น ๆ และห้องซักรีดแบบบริการตนเองเพื่อตอบสนองความต้องการด้านซักรีดของแขก',
    },
    suoxinBuildingaboutfbType1={
      'USA':'Economy Hotel'
    },
    suoxinBuildingaboutfbType2={
      'USA':'Smart Rates for Smart Travellers'
    },
    WeiLaiDifference6={
      'zh-CN': '中央采购系统',
      'USA': 'Central Procurement System',
      'JP': '集中調達システム',
        'KO': '중앙 조달 시스템',
            'TH':'ระบบจัดซื้อจัดจ้างส่วนกลาง',
    },
    WeiLaiDifference6Info={
      'zh-CN': '店vi产品、客用品、印刷品、小商品集中采购。',
      'USA': 'Group purchasing of hotel products, guest supplies, leaflets, small commodities etc.',
      'JP': 'ホテルVI製品、ゲスト用品、リーフレット、小商品のグループ購入。',
        'KO': '호텔 VI 제품, 게스트 용품, 전단지, 소품의 그룹 구매.',
            'TH':'การซื้อผลิตภัณฑ์ Hotel VI, อุปกรณ์สำหรับแขก, แผ่นพับ, สินค้าขนาดเล็ก',
    },
    homePageSwiperFourVacation={
      'zh-CN': '一花一世界 一筑一生活',
      'USA': "Embrace Local Originality",
      'JP': 'フローラルホテル（Floral Hotel） - 地元のオリジナリティを取り入れます。',
        'KO': '플로랄 호텔 (Floral Hotel) - 현지 독창성을 받아들입니다.',
           'TH':'Floral Hotel - โอบกอดความคิดริเริ่มในท้องถิ่น',
    },
    homePageSwiperFourBrandintroductionInof3={
      'zh-CN': '在这里，您可以安然入睡。我们所有的客房都结合了简约、品质和便利，只为让您走入舒适、安全、洁净无瑕的环境。\n' +
          '虽然每一家索性酒店都有其独特的设计风格，但我们的高品质服务都始终如一，致力于带来高性价比的住宿体验。\n' +
          '无论您是双人还是单人出行，商务或者是休闲旅行，我们的团队将以热情和周到迎接每一位客人。 ',
      'USA': ' You are here for a good night\'s sleep. That’s why all our guestrooms combine simplicity, quality and convenience, inviting you into a comfortable, safe and immaculate environment.<br/>While each hotel harbours its own unique design, all deliver the same high quality service and polished décor at a great price. Couples or singles, on business or leisure, our teams welcome everybody with enthusiasm and care.',
      'JP': 'あなたはおやすみなさいの睡眠のためにここにいます。だからこそ、私たちのすべての客室は、シンプルさ、品質、そして便利さを兼ね備えており、快適で安全で清潔な環境にあなたを招待しています。各ホテルは独自のデザインを取り入れていますが、いずれも同じ高品質のサービスと洗練された装飾を手ごろな価格で提供しています。カップルでもシングルでも、ビジネスやレジャーで、私たちのチームは熱意と注意を持ってみんなを歓迎します。',
        'KO': '당신은 좋은 밤 잠을 자려고 여기에 있습니다. 그래서 모든 객실이 단순함, 품질 및 편의성을 결합하여 편안하고 안전하며 뽀얀 환경에 여러분을 초대합니다. 각 호텔은 독특한 디자인을 갖추고 있지만 모두 훌륭한 수준의 서비스와 세련된 실내 장식을 저렴한 가격에 제공합니다. 커플 또는 싱글, 비즈니스 또는 레저, 우리 팀은 열정과 보살핌으로 모두를 환영합니다.',
          'TH':'คุณอยู่ที่นี่เพื่อนอนหลับฝันดี นั่นคือเหตุผลที่ห้องพักทุกห้องของเราผสมผสานความเรียบง่ายคุณภาพและความสะดวกสบายชวนคุณเข้าสู่สภาพแวดล้อมที่สะดวกสบายปลอดภัยและไม่มีที่ติ ในขณะที่โรงแรมแต่ละแห่งได้รับการออกแบบอย่างมีเอกลักษณ์ทุกห้องล้วนมอบบริการคุณภาพสูงและการตกแต่งที่สวยงามในราคาที่ยอดเยี่ยม คู่หรือคนโสดในธุรกิจหรือการพักผ่อนทีมของเรายินดีต้อนรับทุกคนด้วยความกระตือรือร้นและการดูแล',
    },
    homePageSwiperFourDesignideaInfo3={
      'zh-CN': '轻质连锁酒店品牌',
      'USA': 'Economy Hotel',
      'JP': 'エコノミーホテル',
        'KO': '이코노미 호텔',
            'TH':'โรงแรมราคาประหยัด',
    },
    homePageSwiperFiveJoinRemarkTips={
      'zh-CN': '请填写您想咨询的问题',
      'USA': 'Please fill in the questions you want to ask. ',
      'JP': 'あなたが尋ねたい質問を記入してください。',
        'KO': '질문 할 내용을 기입하십시오.',
          'TH':'กรุณากรอกคำถามที่คุณต้องการถาม',
    },
    // groupTitle={
    //   'zh-CN': '关于旅悦-旅悦集团官网',
    //   'USA': 'ホテルハイアット社の公式サイトについて',
    //   'JP': 'LvYueグループについて',
    //     'KO': '그라니스-행열의 공식 홈페이지에 대해서요',
    //     'TH':'เกี่ยวกับการเดินทาง กองพ.ยู.',
    // },
    joinUsInfo={
      'zh-CN': '旅悦集团是携程集团的战略投资公司，以“携手大数据，拥抱互联网”为特色；花筑是集团旗下的首个客栈连锁品牌，现诚邀您筑梦掘金未来，期待您的加盟。',
      'USA': 'LvYue Group is a strategic investment company of Ctrip Group, featured by "Tapping into big data and embracing the Internet", devoted to building the Group into a whole-industry-chain service provider abreast of global peers driven by data. We sincerely invite you to build ourdreams and tap into future with us, and we look forward to your joining.',
      'JP': '',
        'KO': '',
          'TH':'',
    },
    payNewsMoney={
      'zh-CN': '（收费浏览：5元）',
      'USA': '(Charged Browsing: 5 Yuan)',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    payNewsMoney1={
      'zh-CN': '(支付金额：5元)',
      'USA': '(Charged Browsing: 5 Yuan)',
      'JP': '',
        'KO': '',
          'TH':'',
    },
    teamLeaderName1 = {
      'zh-CN': '周荣',
      'USA': 'Zhou Rong',
      'JP': 'Zhou Rong',
      'KO': 'Zhou Rong',
      'TH':'Zhou Rong (โจวหยง)',
    },
    teamLeaderName2 = {
      'zh-CN': '周亚钢',
      'USA': 'Zhou Yagang',
      'JP': '周ヤガン',
        'KO': '저우 야간',
              'TH':'Zhou Yagang',
    },
    teamLeaderName3 = {
      'zh-CN': '邹正宸',
      'USA': 'Zou Zhengchen',
      'JP': 'Zou Zhengchen',
      'KO': 'Zou Zhengchen',
      'TH':'Zou Zhengchen',
    },
    Leadership = {
      'zh-CN': '集团领导',
      'USA': 'Leadership',
      'JP': 'リーダーシップ',
        'KO': '지도',
            'TH':'ความเป็นผู้นำ',
    },
    LeadershipIntro = {
      'zh-CN': '集团领导介绍',
      'USA': 'Leadership Introduction',
      'JP': '集団の指導者の紹介',
        'KO': '그룹 지도부',
           'TH':'ผู้นํากลุ่มแนะนํา',
    },
    LeadershipTitle1 = {
      'zh-CN': '集团领导-旅悦集团官网',
      'USA': 'Leadership',
      'JP': 'グループリーダー・ホードハイムの公式サイト',
        'KO': '그룹지도자 - 헤이트 공식 사이트',
             'TH':' ผู้นํากลุ่ม - กองพลอืนยูไนเต็ด',
    },
    teamLeader1 = {
      'zh-CN': '<p class="executive_title">周荣</p><p class="executive_job">旅悦集团CEO</p>',
      'USA': '<span class="executive_title">Zhou Rong</span><span class="executive_job_usa">CEO of Lvyue Group </span>',
      'JP': '<p class="executive_title">Zhou Rong</p><p class="executive_job">CEO of Lvyue Group </p>',
        'KO': '<p class="executive_title">Zhou Rong</p><p class="executive_job">CEO of Lvyue Group </p>',
           'TH':'<p class="executive_title">Zhou Rong</p><p class="executive_job">CEO of Lvyue Group </p>',
    },
    teamLeader2 = {
      'zh-CN': '<p class="executive_title">邹正宸</p><p class="executive_job">旅悦集团CSO</p>',
      'USA': '<span class="executive_title">Zou Zhengchen</span><span class="executive_job_usa">CSO of Lvyue Group</span>',
      'JP': '<p class="executive_title">Zou Zhengchen</p><p class="executive_job">CSO of Lvyue Group</p>',
        'KO': '<p class="executive_title">Zou Zhengchen</p><p class="executive_job">CSO of Lvyue Group</p>',
           'TH':'<p class="executive_title">Zou Zhengchen</p><p class="executive_job">CSO of Lvyue Group</p>',
    },
    teamLeaderZhiwei1 = {
      'zh-CN': '去哪儿网总裁 旅悦集团CEO',
      'USA': '',
      'JP': '',
        'KO': '',
           'TH':'',
    },
    teamLeaderZhiwei2 = {
      'zh-CN': '旅悦集团COO',
      'USA': '',
      'JP': '',
        'KO': '',       'TH':'',
    },
    teamLeaderZhiwei3 = {
      'zh-CN': '旅悦集团CFO',
      'USA': '',
      'JP': '',
        'KO': '',       'TH':'',
    },
    teamLeaderDesc1 = {
      'zh-CN': '上海交通大学金融硕士及国际金融学士学位。<br/>2004年加入携程，历任携程审计部、新业务发展部负责人；随公司的扩张，参与了易游网、永安旅游、天海邮轮的收购整合和创立的工作。<br/>2015年7月任艺龙首席运营官。<br/>2018年担任携程大住宿事业群首席商务官（CBO）。<br/>2020年2月出任携程大住宿首席战略官（CSO），负责平台、产品，以及大住宿控股公司的管理工作。<br/>2020年12月，出任旅悦集团CEO。',
      'USA': 'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'JP': 'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'KO': 'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'TH':'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
      'YH':'Master of Finance and Bachelor of International Finance from Shanghai Jiao Tong University.<br/>He joined Trip.com Group in the year of 2004, and had performed successively as the head of Auditing Department and New Business Development. With the expansion of the company, he participated in the acquisition, integration and establishment of Elong, Inc., Wing On Travel and SkySea Holding International Ltd.<br/>Chief Operating Officer of Elong, Inc. in July 2015.<br/>In 2018, he served as the Chief Business Officer (CBO) of Accommodation Business Group in Trip.com Group.<br/>In February 2020, he served as the Chief Strategic Officer (CSO) of Accommodation Business Group of Trip.com Group, responsible for the management of platform, products and holding companies of Accommodation Business Group.<br/>CEO of Lvyue Group in December, 2020.',
    },
    teamLeaderDesc2 = {
      'zh-CN': '邹正宸毕业于北京大学和北京信息工程学院，拥有工商管理硕士和计算机软件学士学位。<br/>加入旅悦之前，先后服务于中科院软件所、艺龙和携程旅行网，历任艺龙产品副总裁、携程大住宿产品和创新副总裁等职务，有丰富的互联网产品研发和旅游行业经验。<br/>2020年12月出任旅悦集团首席战略官（CSO），负责产品研发和平台体系建设。',
      'USA': 'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'JP': 'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'KO': 'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'TH':'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
      'YH':'Zou Zhengchen graduated from Peking University with a Master of Business Administration and Beijing Institute of Information Engineering with a bachelor`s degree in Computer Software.<br />Before being associated with Lvyue Group, he successively served in the Institute of software of Chinese Academy of Sciences, Elong, Inc. and Trip.com Group. He has consecutively performed as Vice president of Products in Elong, Inc.  Vice president of Products and Innovation of Accommodation Business Group in Trip.com Group, and he also has rich experience in Internet product development and tourism industry.<br />He has become the Chief Strategic Officer (CSO) of LvYue group in December 2020, responsible for R&D of products and building of platform system.',
    },
    TalentRecruitment={
      'zh-CN': '人才招聘',
      'USA': 'Careers',
      'JP': '',
        'KO': '',       'TH':'',
    },
    joinUsAD={
      'zh-CN': '携手旅悦，<br>用互联网大数据做酒店',
      'USA': 'Be part of LvYue Group<br/> Powered by Internet and Big Data <br/>Be a hotel that customers need more',
      'JP': 'Lu Yueと一緒に参加して、<br>インターネットビッグデータを利用してホテルを作りましょう',
        'KO': '왕위 여행을 위해 손을 잡고 인터넷을 이용하여 호텔을 운영하십시오.',
           'TH':'จับมือกันในการเดินทาง Yue <br>ใช้อินเทอร์เน็ตข้อมูลขนาดใหญ่ที่จะทำโรงแรม',
    },
    joinUsGroupInfo={
      'zh-CN': '旅悦集团成立于2016年，经去哪儿网内部孵化而成，前携程大住宿首席战略官周荣担任集团CEO。由携程集团战略投资，腾讯、红杉资本中国基金、百度资本、高盛集团、鸥翎投资、中信聚信、元禾原点、凯撒辉耀均为投资方。<br/>是一家集酒店管理、信息技术服务、供应链采购贸易、文化旅游于一体的综合性旅游产业集团。依托资深的团队及携程、去哪儿两大OTA巨头的大数据和流量支持，致力于成为最值得信赖的目的旅游服务品牌，为消费者提供旅游度假中的「吃住行，游购娱」360°全方位服务。',
      'USA': 'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.<br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
      'JP': 'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.<br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
        'KO': 'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.<br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
        'TH':'Lvyue Group was established in 2016, after incubating inside Qunar.com.  Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group, served as CEO of the Lvyue Group, also invested by Tencent, Sequoia Capital China Fund, Baidu Capital, Goldman Sachs Group, Ocean Link Investment, CITIC, Oriza Seed and CAISSA Tourism.<br/><br/>Lvyue Group is a comprehensive tourism company integrating hotel management, information technology services, supply chain procurement, and tourism. Relying on its experienced management team and the big data support of Ctrip and Qunar, the two major Chinese OTA players, Tripmod Group is committed to becoming the most trusted destination travel service brand providing guests with \"Food, Hospitality, Travel, Shopping and Entertainment\" full services.',
    },
    joinUsIncloudBrand={
      'zh-CN': '旗下品牌',
      'USA': 'Brand Portfolio ',
      'JP': 'そのブランド',
        'KO': '그 브랜드.',
           'TH':'แบรนด์ของมัน',
    }
    joinUsInAdvantage={
      'zh-CN': '加盟优势',
      'USA': 'Franchise & Cooperation Advantages',
      'JP': '優位に立つ',
        'KO': '가입 혜택.',
           'TH':'เข้าร่วมได้เปรียบ',
    },
    joinUsInAdvantage1Title={
      'zh-CN': '品牌流量加持',
      'USA': 'Brand Generated Traffic Support ',
      'JP': 'ブランドフローの祝福',
        'KO': '브랜드 흐름 축복.',
           'TH':'พรกระแสแบรนด์',
    },
    joinUsInAdvantage1Info={
      'zh-CN': '携程战略控股，去哪儿携程海量数据支持，轻松尽览大住宿数据，助力酒店经营',
      'USA': 'Ctrip strategic holding, where to go, Ctrip massive data support, easy access to big accommodation data, help hotel management',
      'JP': 'シートリップ戦略ホールディングスは、どこにシートリップ海量のデータをサポートしますか？',
        'KO': '전략 적 지주, 어디 에 대량의 데 이 터 를 가지 고 지원 하 는 지, 숙박 데 이 터 를 쉽게 볼 수 있 고 호텔 경영 에 도움 을 줄 수 있 습 니 다.',
           'TH':'แบกเฉิงกลยุทธ์การควบคุมที่พกเฉิงสนับสนุนข้อมูลขนาดใหญ่ได้อย่างง่ายดายดูข้อมูลที่พักใหญ่ช่วยให้โรงแรมวิ่ง',
    },
    joinUsInAdvantage2Title={
      'zh-CN': '更多客源支持',
      'USA': 'More customer support ',
      'JP': 'より多くの顧客サポート',
        'KO': '더 많은 고객 지원.',
           'TH':'สนับสนุนแหล่งข้อมูลเพิ่มเติม',
    },
    joinUsInAdvantage2Info={
      'zh-CN': '专业运营团队，数千家旅行社单位/企业客户资源',
      'USA': 'Professional operation team, thousands of travel agency units / enterprise customer resources',
      'JP': '専門の運営チーム、数千の旅行会社の単位/企業の取引先の資源',
        'KO': '전문 운영 팀, 수천 개 여행사 단위 / 기업 고객 자원',
           'TH':'ทีมปฏิบัติการมืออาชีพหลายพันหน่วยงานการท่องเที่ยวและทรัพยากรของลูกค้าองค์กร',
    },
    joinUsInAdvantage3Title={
      'zh-CN': '经营状态改善',
      'USA': 'Business improvement',
      'JP': '経営状態の改善',
        'KO': '경영 상태 개선',
           'TH':'การปรับปรุงสภาพธุรกิจ',
    },
    joinUsInAdvantage3Info={
      'zh-CN': '入住率提升',
      'USA': 'Increased occupancy',
      'JP': 'チェックイン率が上がる',
        'KO': '입주 율 증가.',
           'TH':'เพิ่มอัตราการเข้าพัก'
    },
    joinUsInAdvantage4Title={
      'zh-CN': '强大的技术支持',
      'USA': 'Strong technical support',
      'JP': '強力な技術サポート',
        'KO': '강력 한 기술 지원',
           'TH':'การสนับสนุนทางเทคนิคที่แข็งแกร่ง',
    },
    joinUsInAdvantage4Info={
      'zh-CN': '提供专业选址系统及XPMS门店管理系统',
      'USA': 'Provide professional location system and XPMS store management system',
      'JP': '専門サイト選択システムとXMS店舗管理システムを提供します。',
        'KO': '전문 입지 선정 시스템 및 XPMS 매장 관리 시스템 제공',
           'TH':'ให้บริการระบบการเลือกเว็บไซต์มืออาชีพและระบบการจัดการร้าน xpms',
    },
    joinUsInAdvantage5Title={
      'zh-CN': '全方位会员体系',
      'USA': 'Fast Developing Loyalty Program  ',
      'JP': '全方向メンバーシップシステム',
        'KO': '무 지향성 멤버쉽 시스템.',
           'TH':'ระบบสมาชิกภาพรอบทิศทาง',
    },
    joinUsInAdvantage5Info={
      'zh-CN': '共享花筑全球会员体系，精准营销，个性化服务',
      'USA': 'Sharing Huazhu global membership system, precision marketing and personalized service',
      'JP': '共有花は全世界の会員システムを構築し、正確な営業、個人化サービスを提供します。',
        'KO': '공유 꽃 은 글로벌 회원 시스템 구축, 정확 한 마 케 팅, 맞 춤 형 서비스 구축',
           'TH':'แบ่งปันดอกไม้สร้างระบบสมาชิกทั่วโลกการตลาดที่ถูกต้องและบริการส่วนบุคคล',
    },
    joinUsInAdvantage6Title={
      'zh-CN': '酒店人才输出',
      'USA': 'Hotel Talents Pool  ',
      'JP': 'ホテルの才能輸出',
        'KO': '호텔 인재 수출.',
           'TH':'การส่งออกความสามารถของโรงแรม',
    },
    joinUsInAdvantage6Info={
      'zh-CN': '成立“旅悦大学”，由酒店行业专家进行授课，统一管理人才输出',
      'USA': '"Lvyue University" was established, which was taught by hotel industry experts and managed talent output in a unified way',
      'JP': '「旅悦大学」を設立し、ホテル業界の専門家による授業を行い、人材輸出を統一的に管理する',
        'KO': '\'여 위 에 대학\' 을 설립 하여 호텔 업계 전문가 가 강 의 를 하고 인 재 를 통일 적 으로 관리 하여 수출 한다.',
           'TH':'การจัดตั้งมหาวิทยาลัยท่องเที่ยวจะสอนโดยผู้เชี่ยวชาญในอุตสาหกรรมโรงแรม',
    },
    joinUsInAdvantage7Title={
      'zh-CN': '一站式采购平台',
      'USA': 'One-stop Purchasing platform',
      'JP': 'ワンストップ購買プラットフォーム',
        'KO': '원 스톱 구매 플랫폼.',
           'TH':'แพลตฟอร์มการซื้อแบบครบวงจร',
    },
    joinUsInAdvantage7Info={
      'zh-CN': '全酒店物质供应链统一集采，高效低成本，同时提供专业的民宿设计施工',
      'USA': 'The material supply chain of the whole hotel is unified and centralized, with high efficiency and low cost',
      'JP': '全ホテルの物質供給チェーンは統一的に収集され、高効率で低コストで、同時に専門の民宿設計施工を提供します。',
        'KO': '호텔 전체 물질 공급 체인 을 통일 적 으로 수집 하고 효율 적 이 며 원가 가 낮 으 며 전문 적 인 민 박 설계 시공 도 제공한다.',
           'TH':'ห่วงโซ่อุปทานของวัสดุทั้งหมดของโรงแรมรวมคอลเลกชันที่มีประสิทธิภาพและค่าใช้จ่ายต่ำขณะที่ให้บริการออกแบบและก่อสร้างที่พักมืออาชีพ',
    },
    joinUsInAdvantage8Title={
      'zh-CN': '专业的OTA运营',
      'USA': 'Professional OTA Operations ',
      'JP': 'プロのOTAオペレーション',
        'KO': '전문 OTA 작업.',
           'TH':'การทำงาน OTA แบบมืออาชีพ',
    },
    joinUsInAdvantage8Info={
      'zh-CN': 'OTA精细化运营，一对一服务酒店，从数据分析，竞对模型分析，流量推广，收益排名提升，提供全方位解决方案',
      'USA': 'Providing a full range of revenue-driven solutions for OTA management, including one-to-one service, data and revenue analysis, traffic promotions and ranking improvement assistance. ',
      'JP': 'OTAの細かい操作、データ分析から、予想外にモデル分析、トラフィックプロモーション、収益ランキングまで、一対一のサービスホテルで、幅広いソリューションを提供します。',
        'KO': 'OTA 벌금 작업, 일대일 서비스 호텔, 데이터 분석에서 예기치 않게 모델 분석, 교통 홍보, 수익 랭킹까지 다양한 솔루션을 제공합니다.',
           'TH':'การดำเนินการที่ดี OTA โรงแรมบริการแบบหนึ่งต่อหนึ่งจากการวิเคราะห์ข้อมูลโดยไม่คาดคิดไปจนถึงการวิเคราะห์รูปแบบการส่งเสริมการขายการจัดอันดับรายได้เพื่อมอบโซลูชั่นที่ครบวงจร',
    },
    joinUsDisclaimer={
     'zh-CN': '以上数据来自于已开业门店，每家门店实际情况不一，数据仅作参考。',
     'USA': 'The above data comes from the stores that have opened. The actual situation of each store is different. The data is for reference only.',
     'JP': '以上のデータはすでにオープンした店舗から来ています。店舗ごとに実際の状況が異なります。データは参考にしてください。',
     'KO': '이상 의 데 이 터 는 이미 개업 한 가게 에서 나 온 것 으로 모든 가게 의 실제 상황 이 다 르 기 때문에 데 이 터 는 참고 만 할 수 있 습 니 다. 데이터분석으로부터 시작한 경쟁사 분석,마켓팅,랭킹관리,솔루션 제공',
     'TH':'ข้อมูลข้างต้นมาจากร้านค้าที่เปิดขึ้นสถานการณ์จริงของแต่ละร้านแตกต่างกันข้อมูลใช้สำหรับอ้างอิงเท่านั้น',
    },
    joinUsInMessageTitle={
      'zh-CN': '留联系方式',
      'USA': 'Leave your phone number',
      'JP': '連絡電話',
        'KO': '연락처',
           'TH':'เบอร์ติดต่อ',
    },
    joinUsInMessageInfo={
      'zh-CN': '留下联系方式，会有专属加盟顾问为您解答',
      'USA': 'leave your contact information, an exclusive franchise consultant will contact you.',
      'JP': '連絡先情報と懸念の内容を残す、あなたのために答えるために排他的なコンサルタントがあるでしょう。',
        'KO': '연락처 정보와 우려되는 내용을 남겨두면 독점적 인 컨설턴트가 응답 해줍니다.',
           'TH':'ออกจากข้อมูลการติดต่อและเนื้อหาของความกังวลจะมีที่ปรึกษาพิเศษเพื่อตอบคุณ',
    },
    telNum={
      'zh-CN': '400-898-7118',
      'USA': '400-898-7118',
      'JP': '400-898-7118',
        'KO': '400-898-7118',
           'TH':'400-898-7118',
    },
    email={
      'zh-CN': '客服邮箱',
      'USA': 'Email',
      'JP': 'メールアドレス',
        'KO': '이메일 주소',
           'TH':'อีเมล',
    },
        chooseTelPre={
      'zh-CN': '请选择区号',
      'USA': 'Please select an area code.',
      'JP': '市外局番を選択してください。',
        'KO': '지역 번호를 선택하십시오.',
           'TH':'โปรดเลือกรหัสพื้นที่',
    },
    chooseLanguage={
      'zh-CN': '请选择语言',
      'USA': 'Please choose language',
      'JP': '言語を選択してください',
        'KO': '언어를 선택하십시오.',
           'TH':'กรุณาเลือกภาษา',
    },
    toolbarCloseText={
      'zh-CN': '确定',
      'USA': 'Submit',
      'JP': '提出する',
        'KO': '제출',
           'TH':'ยืนยัน',
    },
    submitInfoTelPre = {
      'zh-CN': '+86',
      'USA': '+1',
      'JP': '+81',
        'KO': '+82',
           'TH':'+66',
    },
    submitsucBtn = {
      'zh-CN': '确定',
      'USA': 'OK',
      'JP': '提出する',
        'KO': '제출',
           'TH':'ยืนยัน',
    },
    submitCancelBtn = {
      'zh-CN': '取消',
      'USA': 'Cancel',
      'JP': 'キャンセル',
        'KO': '취소',
           'TH':'ยกเลิก',
    },
    submitsucTitle = {
      'zh-CN': '提交信息成功！',
      'USA': 'Successful submission of information! ',
      'JP': '情報を送信してください！',
        'KO': '성공적인 정보 제출!',
           'TH':'ส่งข้อมูลสำเร็จแล้ว!',
    },
    joinUsTel = {
        'zh-CN': '<span>加盟热线</span><a href="tel:+86 400-898-7118">86 400-898-7118</a>',
        'USA': '<span>Franchise Telephone</span><a href="tel:0086-400-898-7118">0086-400-898-7118</a>',
        'JP': '<span>お問合せ</span><a href="tel:0081-6-66269343">0081-6-66269343</a>',
        'KO': '<span>가맹문의</span><a href="tel:0082-70-4919-7032">0082-70-4919-7032</a>',
        'TH':'<span>แฟรนไชส์ โทร.Mr.Eric Wu</span><a href="tel:+0066-83-5238098">0066-83-5238098</a>',
    },
    joinUsMail = {
        'zh-CN': '邮箱地址',
        'USA': 'Email',
        'JP': 'Eメール',
        'KO': '이메일',
        'TH':'อีเมล',
    },
        submitsucCon = {
            'zh-CN': '专职加盟顾问会及时联系您请注意接听来电',
            'USA': 'The full-time consultant will contact you in time. Please pay attention to answer the call. ',
            'JP': '専任コンサルタントが電話で対応いたします。',
            'KO': '풀 타임 컨설턴트가 시간 내에 연락 할 것입니다. 전화 응답에주의하십시오.',
            'TH':'ทีมที่ปรึกษามืออาชีพจะติดต่อคุณทันที กรุณารอการติดต่อกลับ',
        },
        tanchenTitle={
          'zh-CN': '檀程酒店、客栈、民宿品牌介绍-旅悦集团官网',
          'USA': 'Arula Hotel-Floral Travel',
        },
        commonTanChen={
          'zh-CN': '檀程',
          'USA': 'Arula',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':'',
        },
        buftlanguage1={
         'zh-CN': '休闲放松',
         'USA': ' Unwind  ',
        },
        decslan1={
         'zh-CN': '环境舒适安静，伴您好梦酣眠 <br/>现代化网络设备，享受轻松时光<br/> 品质洗浴设施，尽情放松身心 <br/>',
         'USA': ' Comfortable and quiet for a deep sleep.<br/> Modern and connected for a relaxing time.<br/>Quality amenities for a soothing shower. <br/>  ',
        },
        buftlanguage2={
         'zh-CN': '商务办公',
         'USA': ' Work  ',
        },
        decslan2={
         'zh-CN': '客房配备小型办公区，满足商<br/> 务办公需求<br/>',
         'USA': ' A small office area is here for you <br/> to finish your business preparations ',
        },
        buftlanguage3={
         'zh-CN': '智能连接',
         'USA': ' Connected  ',
        },
        decslan3={
         'zh-CN': ' 无论工作或是娱乐 <br/>智能电视和高速网络让您的入<br/> 住体验更加丰富多彩 <br/>',
         'USA': ' For work or fun, our smart TV and <br/> high-speed internet are here to <br/> enrich guests room experience' ,
        },
        aruati={
         'zh-CN': '客房',
         'USA': ' Room  ',
        },
        tanchenDesignType1={
         'zh-CN': '心驰神往 ',
         'USA': 'Inviting  ',
        },
        tanchenDesignType2={
         'zh-CN': '怡然自得 ',
         'USA': ' Comfortable ',
        },
        tanchenDesignType3={
         'zh-CN': '彬彬有礼 ',
         'USA': 'Courteous  ',
        },
        tanchenDesign={
         'zh-CN': '檀程设计理念 ',
         'USA': 'Design Philosophy of Arula Hotels & Resorts  ',
        },
        tanchenBrandIntroductionTitle={
         'zh-CN': '檀程·品牌介绍 ',
         'USA': ' Arula Hotels & Resorts ',
        },
        tanchenBuildingaboutfbType1={
         'zh-CN': '高端酒店及度假村 ',
         'USA': 'Premium Hotels & Resorts  ',
        },
        tanchenBrandIntroductionInfo={
         'zh-CN': '高端酒店及度假村品牌檀程，为您提供融合中式热情与国际化标准的待客之道。<br/>每一家檀程都独具特色，对极致服务的追求则如出一辙。优越地段、殷勤款待、佳肴美馔……至于此，沉浸悠闲惬意之旅。<br/>无论是商务或是休闲，在您踏入酒店的第一刻，宾至如归的感受将和关怀备至的员工一起，时时伴您左右。 ',
         'USA': 'Arula is a premium hotels and resorts brand combining international hospitality with a true sense of Chinese welcome. While every Arula hotel is unique, all share the same dedication for high-quality service. Discover excellently located hotels that offer caring attentions, delightful food and drink, and places to relax. Helped by calm and considerate employees, guests find it easy to pursue their own design, whether it is business or pleasure.  ',
        },
        tanchenBuildingaboutfbType3={
         'zh-CN': '檀程，尽享心意之地。 ',
         'USA': 'Our ambition. Help you follow yours.  ',
        },
        acTl1={
         'zh-CN': ' 城中世外桃源',
         'USA': 'Atmosphere Ambition ',
        },


        acDec1={
         'zh-CN': '简约、宁静、中式优雅 ',
         'USA': 'Simple Design &nbsp&nbsp    Quiet Atmosphere &nbsp&nbsp    Chinese Elegance ',
        },
        acDF1={
         'zh-CN': '高贵典雅与静谧宁和交融于此，<br/>温馨与精致渗透于细节之中，<br/>在轻松愉悦中享用美食、放松身心，体验中式殷勤待客之道，这里是现代旅行者停泊的理想港湾。 ',
         'USA': 'Premium and quiet atmosphere, combining, warm and refined materials and sensations, to create effortless places where<br/> gastronomy, well-being, and the spirit of Chinese hospitality are put in perspective to please modern travellers. ',
        },
        acTl2={
         'zh-CN': '美酒佳肴 ',
         'USA': 'Wine & Dine',
        },
        acDF2={
         'zh-CN': '从开启美好一天的早餐，到悠然享用的晚餐，檀程时刻准备着愉悦您的味蕾。您可以在全日餐厅中品尝种类丰富的环球美馔，也可以在中餐厅体验地道中式佳肴与周到服务的双重享受。 ',
         'USA': 'From the most important breakfast to an evening well deserved bite, Arula’s all-day dining welcome guests with a wide array of world delicacies, while the Chinese restaurant is ready to delight taste buds with authentic local cuisine and tailored service.',
        },


        acTl3={
         'zh-CN': '会议 ',
         'USA': 'Meeting',
        },
        acDF3={
         'zh-CN': '无论您是需要召开小型会议还是举办大型会议或庆典，檀程的多功能厅将满足您的各种需求，设计风格现代时尚的会议及宴会厅均配备先进的视听设备。 <br/><br/>专业的会议协调员将全程为您的活动开展提供协助，满足您的所有特定需求。 ',
         'USA': 'Arula Hotels & Resorts offer a choice of facilities ranging from boardroom for executive meeting to ballroom for larger scale events & celebrations, all featuring modern design and state-of-the-art equipment.<br/>A dedicated events coordinator assists you through every planning stage to meet all of your specific needs and requests.',
        },commonTh={
          'zh-CN': 'ภาษาไทย',
          'USA': 'ภาษาไทย',
          'JP': 'ภาษาไทย',
          'KO': 'ภาษาไทย',
          'TH':'ภาษาไทย',
          'YH':'ภาษาไทย',
        },
        commonYh={
          'zh-CN': 'Tiếng Viê',
          'USA': 'Tiếng Viê',
          'JP': 'Tiếng Viê',
          'KO': 'Tiếng Viê',
          'TH':'Tiếng Viê',
          'YH':'Tiếng Viê',
        },
        commonReservations={
          'zh-CN': '预订酒店',
          'USA': 'Reservation',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':'',
        },
        commonClose={
          'zh-CN': '关闭',
          'USA': 'Close',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':'',
        },
        commonFreebooking={
          'zh-CN': '免费订房热线',
          'USA': 'Free Booking Hotline',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':'',
        },
        commonDownload={
          'zh-CN': '下载花筑旅行APP预订酒店',
          'USA': 'Download Floral Travel APP for Hotel Reservation',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':'',
        },
        commonWechatSubscription={
          'zh-CN': '关注花筑旅行公众账号',
          'USA': 'Follow Floral Travel on Wechat',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':'',
        },    floralReservation = {
          'zh-CN': '酒店预订',
          'USA': 'Reservation',
          'JP': '予約',
          'KO': '호텔 예약',
          'TH':'การจองโรงแรม',
          'YH':'Đặt chỗ'
        },
        floralReservationDetail1 = {
          'zh-CN': '官网预订折扣',
          'USA': 'Special membership ratesBest rate guaranteed',
          'JP': '公式ウェブサイト特別料金ベストレート保証',
          'KO': '공식사이트 예약 특별할인',
          'TH':'ส่วนลดพิเศษในเว็บไซต์ทางการ',
          'YH':'Giá đặc biệt trên trang web chính thức'
        },
        floralReservationDetail2 = {
          'zh-CN': '旅游攻略',
          'USA': '',
          'JP': '',
          'KO': '',
          'TH':'',
          'YH':''
        },
        commonJtc={
          'zh-CN': '檀程',
          'USA': 'Arula  ',
          'JP': ' Arula',
             'KO': 'Arula   ',
          'TH':'Arula ',
          'YH':'Arula '

         },
         indexTanchen={
          'zh-CN': '檀程',
          'USA': 'Arula Hotels & Resorts  ',
         },
         indexInfo={
          'zh-CN': '高端酒店及度假村品牌',
          'USA': 'Premium Hotels and Resorts  ',
         },
         indexContent={
          'zh-CN': '高端酒店及度假村品牌檀程，为您提供融合中式热情与国际化标准的待客之道。<br/>每一家檀程都独具特色，对极致服务的追求则如出一辙。优越地段、殷勤款待、佳肴美馔……至于此，沉浸悠闲惬意之旅。无论是商务或是休闲，在您踏入酒店的第一刻，宾至如归的感受将和关怀备至的员工一起，时时伴您左右。<br/>',
          'USA': 'Arula is a premium hotels and resorts brand combining international hospitality with a true sense of Chinese welcome. While every Arula hotel is unique, all share the same dedication for high-quality service. Discover excellently located hotels that offer caring attentions, delightful food and drink, and places to relax. Helped by calm and considerate employees, guests find it easy to pursue their own design, whether it is business or pleasure.  ',
         },
         indexFooter={
          'zh-CN': '尽享心意之地',
          'USA': 'Our ambition. Help you follow yours. ',
         },
         groupmeta={
          'zh-CN': '旅悦(天津)酒店管理有限公司，简称旅悦集团，成立于2016年，是携程集团的战略投资公司，前携程大住宿首席战略官周荣担任集团CEO，是一家集酒店管理、信息技术、采购贸易于一体的旅游产业集团。旅悦集团聚焦于旅游产业链实体的建设与运营，致力于将互联网创新技术应用于传统旅游产业链，实现传统行业建设运营的智能化、科技化发展。',
          'USA': 'Lvyue (Tianjin) Hotel Management Co., Ltd., referred to as Lvyue Group, was founded in 2016. It is a strategic investment company of Ctrip Group. Zhou Rong, former Chief Strategy Officer of Accommodation Business Group of Trip.com Group ，served as CEO of the Lvyue Group; Lvyue Group is a tourism industry group integrating hotel management, information technology, procurement and trade. Lvyue Group focuses on the construction and operation of the tourism industry chain, and is committed to applying Internet innovation technology to the traditional tourism industry chain to realize the intelligent, scientific and technological development of the construction and operation of traditional industries.',
         },
         groupkey={
           'zh-CN': '旅悦集团简介,旅悦集团主营业务,酒店管理系统,花筑旅行"',
           'USA': 'Brief introduction of Lvyue Group, main business of Lvyue Group, hotel management system, Floral Trip',
         },
         grouptitle={
           'zh-CN': '关于旅悦-旅悦集团官网',
           'USA': 'About the official website of Lvyue-Lvyue Group ',
         },
         teammeta={
          'zh-CN': '旅悦集团CEO周荣，2004年加入携程、2015年加任艺龙首席运营官、2020年2月出任携程大住宿首席战略官，2018年担任携程大住宿事业群首席商务官；2020年，出任旅悦集团CEO，旅悦集团CSO邹正宸 ，2020年出任旅悦集团首席战略官（CSO）；',
          'USA': '旅悦集团CEO周荣，2004年加入携程、2015年加任艺龙首席运营官、2020年2月出任携程大住宿首席战略官，2018年担任携程大住宿事业群首席商务官；2020年，出任旅悦集团CEO，旅悦集团CSO邹正宸 ，2020年出任旅悦集团首席战略官（CSO）；',
         },
         teamkey={
           'zh-CN': '集团领导,旅悦价值观"',
           'USA': 'group leaders, values of Lvyue',
         },
         teamtitle={
           'zh-CN': '集团领导-旅悦集团官网',
           'USA': '  Group Leadership-Lvyue Group Official Website',
         },
         florameta={
           'zh-CN': '花筑是旅悦集团下的首个精品度假酒店品牌，在全球内甄选极致风景，博采众家之长，策集团之力,注意结合当地文化,致力于打造最具文化特质的度假居停空间。',
           'USA': 'Floral is the first boutique resort hotel brand under the Lvyue Group. It selects the best scenic spots in the world, draws on the strengths of various families, makes efforts of the Group, pays attention to the combination of local culture, and devotes itself to creating the most cultural vacation accommodation space.',
         },
         florakey={
           'zh-CN': '花筑酒店,花筑客栈,花筑民宿,花筑设计理念,花筑品牌',
           'USA': 'Floral Hotel, Floral Inn, Floral Residence, Floral Design Concept, Floral Brand',
         },
         floratitle={
           'zh-CN': '花筑酒店、客栈、民宿品牌介绍-旅悦集团官网',
           'USA': 'Brand Introduction of Floral Hotel, Floral Inn and Floral Hostel- Lvyue Group Official Website ',
         },
         suoxingmeta={
           'zh-CN': '索性是旅悦集团下轻质连锁酒店品牌。以“净，如索性”为品牌理念，深度关注用户对于酒店洁净方面的核心诉求，为快节奏的城市客人提供整洁舒适的住宿体验。',
           'USA': 'Suoxing is the light chain hotel brand of Lvyue Group. With the brand concept of "clean, as simple as nature", we pay close attention to users\'core demands for hotel cleanliness and provide clean and comfortable accommodation experience for fast-paced city guests. ',
         },
         suoxingkey={
           'zh-CN': '索性酒店,索性客栈,索性民宿,索性设计理念,索性品牌',
           'USA': 'suoxing hotel, suoxing inn, suoxing accommodation, suoxing design concept, suoxing brand',
         },
         suoxingtitle={
           'zh-CN': '索性酒店、客栈、民宿品牌介绍-旅悦集团官网',
           'USA': 'Brand introduction of suoxing hotel, suoxing Inn and suoxing accommodation -Lvyue Group official website ',
         },
         Vylukmeta={
           'zh-CN': '蔚徕是旅悦集团下主打新一代生活方式的酒店品牌。遴选城市核心地块，“以不凡，见蔚徕”',
           'USA': 'Vyluk is a hotel brand that focuses on the new generation of lifestyle under the Lvyue Group. Selection of urban core plots, " To be extraordinary, to see Weilai ',
         },
         Vylukkey={
           'zh-CN': '蔚徕酒店,蔚徕客栈,蔚徕民宿,蔚徕设计理念,蔚徕品牌',
           'USA': 'Vyluk Hotel, Vyluk Inn, Vyluk Hostel, Vyluk Design Concept, Vyluk Brand',
         },
         Vyluktitle={
           'zh-CN': '蔚徕酒店、客栈、民宿品牌介绍-旅悦集团官网',
           'USA': 'Brand Introduction of Vyluk Hotel, Vyluk Inn and Vyluk Hostel - Lvyue Group Official Website',
         },
         franchmeta={
           'zh-CN': '旅悦集团“携手大数据，拥抱互联网”致力于打造旅游全产业链服务商，提供加盟合作的电话及流程期待您的咨询。如想了解更多酒店加盟信息（加盟政策，汇报投资率等），可拨打加盟热线或留下联系方式，将会有专属加盟顾问为您解答。',
           'USA': 'Lvyue Group" is committed to building a whole tourism industry chain service provider, providing telephone and process of franchise cooperation, looking forward to your consultation. If you want to know more about hotel franchise information (franchise policy, reporting investment rate, etc.), you can call the franchise hotline or leave contact information, there will be exclusive franchise consultants to answer for you.',
         },
         franchkey={
           'zh-CN': '酒店加盟,客栈加盟,民宿加盟,花筑酒店加盟,索性酒店加盟,蔚徕酒店加盟',
           'USA': 'hotel franchise, Inn franchise, residential franchise, Floral Hotel franchise, Suoxing hotel franchise, Vyluk Hotel franchise',
         },
         franchtitle={
           'zh-CN': '酒店加盟优势/政策_热线/电话/流程/咨询-旅悦集团官网',
           'USA': 'Hotel Joining Advantage/Policy/Hotline/Telephone/Process/Consulting-Lvyue Group Official Website',
         },
         floralTripmeta={
           'zh-CN': '花筑旅行APP是旅悦集团旗下酒店官方预订平台，功能包括：酒店预订、会员权益、旅行攻略、旅途社区、主题活动、玩乐门票；更是涵盖旅游攻略、旅行定制、航拍交友等吃、注、行、游、购、娱于一体的真实旅途互动社区。',
           'USA': 'Floral Trip APP" is the official hotel reservation platform of Lvyue Group. Its functions include hotel reservation, membership rights and interests, travel strategy, travel community, theme activities, tickets for fun, and also includes travel strategy, travel customization, aerial photography, friends, food, notes, travel, travel, shopping and entertainment. Real Travel Interactive Community. '
         },
         floralTripkey={
           'zh-CN': '花筑旅行APP,酒店预订APP,花筑旅行APP功能,酒店预订,旅行攻略',
           'USA': ' Floral Trip APP, Hotel Reservation APP, Floral Trip  APP Function, Hotel Reservation, Travel Strategy'
         },
         floralTripTitle={
           'zh-CN': '花筑旅行APP-酒店预订平台-官网预定折扣-旅悦集团官网',
           'USA': 'Floral Trip APP -Hotel Reservation Platform-Official Reservation Discount-Lvyue Group Official Website'
         },
         tanchenmeta={
           'zh-CN': '檀程酒店（ARULA）是旅悦集团旗下的高端酒店及度假村品牌。每一家都独具特色，不仅融合中式热情服务，更与国际化的标准待客之道接轨，带来宾至如归的感受，让每个客人尽享心意之地。',
           'USA':'Arula is a premium hotels and resorts brand of Lvyue Group. Each hotel has its own characteristics, not only the integration of Chinese-style enthusiastic service, but also in line with the international standard way of hospitality, bring a sense of home, so that every guest can enjoy the heart of the place.'
         },
         tanchenkey={
           'zh-CN': '檀程酒店,檀程客栈,檀程民宿,檀程设计理念,檀程品牌',
           'USA':'Arula hotel, Arula Inn, Arula Hostel, Arula design concept, Arula brand'
         },
         tanchentitle={
           'zh-CN': '檀程酒店、客栈、民宿品牌介绍-旅悦集团官网',
           'USA':' Brand Introduction of Arula hotel, Arula Inn, Arula Hostel and Arula brand- Lvyue Group Official Website'
         },
        homemeta={
          'zh-CN': '旅悦集团旗下花筑、檀程、蔚徕、索性、柏纳、BEU多个品牌，截止目前全球开店1900多家，覆盖中国、日本、韩国、泰国、印度、马来西亚、澳大利亚等10多个国家、200多个目的地，从经济实惠酒店到中高端特色酒店俱全，全方位满足客户个性化、多样化的出游住宿需求。',
          'USA':'Lvyue Group\'s Floral, Arula, Vyluk, SuoXing, Urba and BEU brands have opened more than 1900 stores worldwide, covering more than 10 countries and more than 200 destinations such as China, Japan, Korea, Thailand, India, Malaysia and Australia. They range from affordable hotels to high-end characteristic hotels and meet all-round needs. Customer personalized, diversified travel accommodation needs. '
        },
        homekey={
         'zh-CN': '旅悦集团,酒店加盟,酒店预订,花筑,檀程,索性,蔚徕,柏纳,BEU',
         'USA':'Lvyue Group, Hotel Franchise, Hotel Reservation, Floral, Arula, SuoXing, Vyluk, Urba, BEU '
        },
        hometitle={
          'zh-CN': '旅悦集团官网-花筑、蔚徕、索性、柏纳、BEU酒店品牌',
          'USA':'Lvyue Group Official Website -Floral, Arula, Vyluk, SuoXing, Urba, BEU Hotel Brand '
        }




// WEBPACK FOOTER //
// ./src/js/language.js